const icons = {
  v3_4dots: () => (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2.5" cy="2.5" r="2.5" fill="#757575" />
      <circle cx="2.5" cy="10.5" r="2.5" fill="#757575" />
      <circle cx="10.5" cy="2.5" r="2.5" fill="#757575" />
      <circle cx="10.5" cy="10.5" r="2.5" fill="#757575" />
    </svg>
  ),
  v3_continue: () => (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5L13 4.5V3.5L0 3.5L0 4.5Z"
        fill="#757575"
      />
    </svg>
  ),
  v3_refresh: () => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6856 8.37744L13.6906 8.34182V8.34307C13.7056 8.23182 13.7181 8.11994 13.7269 8.00744C13.7419 7.81869 13.6088 7.50057 13.2588 7.50057C13.0144 7.50057 12.8119 7.68807 12.7919 7.93182C12.7806 8.06994 12.7644 8.20682 12.7431 8.34182C12.34 10.8737 10.1444 12.8124 7.49875 12.8124C5.60063 12.8124 3.93375 11.8143 2.995 10.3156L4.23938 10.3124C4.49813 10.3124 4.70813 10.1024 4.70813 9.84369C4.70813 9.58494 4.49813 9.37494 4.23938 9.37494H1.71875C1.46 9.37494 1.25 9.58494 1.25 9.84369V12.3743C1.25 12.6331 1.46 12.8431 1.71875 12.8431C1.9775 12.8431 2.1875 12.6337 2.1875 12.3743L2.18938 10.7962C3.2925 12.5687 5.25875 13.7499 7.49875 13.7499C10.65 13.7499 13.2594 11.4118 13.6856 8.37744ZM1.32687 6.51869L1.32125 6.55369V6.55244C1.29938 6.69807 1.28188 6.84557 1.27 6.99494C1.255 7.18369 1.38812 7.50182 1.73812 7.50182C1.9825 7.50182 2.185 7.31432 2.205 7.07057C2.21875 6.89557 2.24125 6.72307 2.27188 6.55369C2.71938 4.07369 4.89 2.18994 7.49813 2.18994C9.39625 2.18994 11.0631 3.18807 12.0019 4.68682L10.7575 4.68994C10.4987 4.68994 10.2887 4.89994 10.2887 5.15869C10.2887 5.41744 10.4987 5.62744 10.7575 5.62744H13.2781C13.5369 5.62744 13.7469 5.41744 13.7469 5.15869V2.62807C13.7469 2.36932 13.5369 2.15932 13.2781 2.15932C13.0194 2.15932 12.8094 2.36869 12.8094 2.62807L12.8075 4.20619C11.7044 2.43369 9.73812 1.25244 7.49813 1.25244C4.38312 1.25244 1.79812 3.53619 1.32687 6.51869Z"
        fill="#757575"
      />
    </svg>
  ),
  v3_brain: () => (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.37303 15H1.49458C1.49458 15 1.95335 12.543 1.89022 11.4461C1.86459 10.9936 1.78959 10.5248 1.55271 10.131C1.14956 9.50602 -0.0948628 7.80595 0.00576636 5.4871C0.145772 2.23134 2.93901 0 6.33478 0C9.52116 0 11.6519 1.8757 12.4963 4.67707C12.7013 5.35147 12.6907 5.64023 12.4019 6.30651L12.3982 6.31464L13.4926 7.65344C13.6551 7.89158 13.7507 8.14784 13.7507 8.42785C13.7507 8.76974 13.6051 9.081 13.3694 9.30226C13.1394 9.5179 12.8901 9.58477 12.5894 9.70353C12.5894 9.70353 12.2294 11.3236 12.0438 11.7605C11.6062 12.7874 10.8125 12.7974 10.1874 12.9162C9.94118 12.968 9.88118 12.9993 9.7618 13.3418C9.63179 13.7112 9.53491 14.2387 9.37303 15ZM6.34666 1.24943C3.66842 1.27943 1.50895 2.84199 1.27082 5.3046C1.15081 6.54902 1.56021 7.79595 2.21836 8.87037C2.60025 9.4954 3.03402 9.86541 3.1334 11.2923C3.19027 12.113 3.10215 12.9399 2.98277 13.7499H8.36049C8.44862 13.3468 8.57925 12.8218 8.78988 12.4643C9.07052 11.9855 9.47554 11.7774 9.99368 11.6805C10.5175 11.588 10.7675 11.6436 10.9243 11.1898C11.0569 10.828 11.3069 9.80166 11.4437 8.75099C12.1956 8.54161 11.8263 8.65036 12.4882 8.4016C12.3594 8.25534 11.2894 6.95529 11.21 6.77653C11 6.30214 11.1812 6.03275 11.3506 5.58086C11.4044 5.42398 11.3881 5.35772 11.345 5.19772C10.6893 2.72949 8.91301 1.24943 6.34666 1.24943ZM6.67167 3.12451C6.82293 3.55202 6.86668 3.82578 7.19732 3.96267C7.52858 4.1008 7.75609 3.93516 8.16236 3.74203L8.75801 4.33706C8.563 4.74645 8.39987 4.97208 8.53675 5.3021C8.67363 5.63211 8.94489 5.67586 9.37553 5.82837V6.67028C8.94989 6.82216 8.67363 6.86591 8.53675 7.19718C8.39924 7.52781 8.56362 7.75407 8.75801 8.16221L8.16236 8.75724C7.75171 8.56161 7.52858 8.39847 7.19919 8.53536C6.8673 8.67411 6.82293 8.9485 6.67167 9.37477H5.82913C5.67788 8.94725 5.63413 8.67349 5.30349 8.53723L5.30286 8.5366C4.97222 8.39847 4.74534 8.56348 4.33782 8.75724L3.7428 8.16221C3.93343 7.76032 4.10156 7.53031 3.96343 7.19655C3.82593 6.86591 3.55029 6.82216 3.12527 6.67028V5.82837C3.55091 5.67711 3.82593 5.63336 3.96343 5.30272C4.10094 4.97083 3.93718 4.74582 3.7428 4.33706L4.33782 3.74203C4.74846 3.93704 4.97222 4.10017 5.30286 3.96267C5.6335 3.82578 5.67788 3.54952 5.82913 3.12451H6.67167ZM6.2504 7.29155C5.67538 7.29155 5.20848 6.82528 5.20848 6.24963C5.20848 5.67399 5.67538 5.20772 6.2504 5.20772C6.82543 5.20772 7.2917 5.67399 7.2917 6.24963C7.2917 6.82528 6.82543 7.29155 6.2504 7.29155Z"
        fill="#757575"
      />
    </svg>
  ),
  v3_copy: () => (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1126_3135)">
        <rect width="21" height="21" fill="#F1F1F1" />
        <path
          d="M16.75 6.75V16.75H6.75V6.75H16.75ZM18 5.5H5.5V18H18V5.5ZM3 16.125V3H16.125V4.25H4.25V16.125H3Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_1126_3135">
          <rect width="21" height="21" rx="3.75" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  v3_filter: () => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2293 11.8516C10.2293 11.5756 10.0053 11.3516 9.72931 11.3516H6.28931C6.01331 11.3516 5.78931 11.5756 5.78931 11.8516C5.78931 12.1276 6.01331 12.3516 6.28931 12.3516H9.72931C10.0053 12.3516 10.2293 12.1276 10.2293 11.8516ZM11.7 9.1849C11.7 8.9089 11.476 8.6849 11.2 8.6849H4.80265C4.52665 8.6849 4.30265 8.9089 4.30265 9.1849C4.30265 9.4609 4.52665 9.6849 4.80265 9.6849H11.2C11.476 9.6849 11.7 9.4609 11.7 9.1849ZM13.3333 6.51823C13.3333 6.24223 13.1093 6.01823 12.8333 6.01823H3.16665C2.89065 6.01823 2.66665 6.24223 2.66665 6.51823C2.66665 6.79423 2.89065 7.01823 3.16665 7.01823H12.8333C13.1093 7.01823 13.3333 6.79423 13.3333 6.51823ZM14.6666 3.85156C14.6666 3.57556 14.4426 3.35156 14.1666 3.35156H1.83331C1.55731 3.35156 1.33331 3.57556 1.33331 3.85156C1.33331 4.12756 1.55731 4.35156 1.83331 4.35156H14.1666C14.4426 4.35156 14.6666 4.12756 14.6666 3.85156Z"
        fill="#757575"
      />
    </svg>
  ),
  pintask: (props) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.986"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.17475 0C8.2614 0 8.34802 0 8.43467 0C9.60614 1.12679 10.7679 2.26741 11.92 3.42188C12.0074 3.5456 12.0232 3.6784 11.9673 3.82031C11.5796 4.22309 11.1228 4.31684 10.5968 4.10156C9.597 5.24953 8.5967 6.39797 7.59583 7.54688C7.70646 7.72118 7.80098 7.90868 7.87938 8.10938C8.03659 8.7086 7.89086 9.22031 7.44224 9.64453C7.31672 9.71972 7.19068 9.71972 7.06417 9.64453C6.42192 9.00359 5.77604 8.36686 5.12656 7.73438C4.28739 8.56284 3.4446 9.38705 2.59822 10.207C1.89772 10.828 1.18096 11.4256 0.447953 12C0.361311 12 0.274672 12 0.18803 12C-0.0502457 11.8054 -0.0620603 11.5944 0.152586 11.3672C0.654688 10.7441 1.17453 10.1347 1.71212 9.53906C2.57393 8.66081 3.44427 7.78971 4.32316 6.92578C3.64186 6.25001 2.96053 5.57421 2.27923 4.89844C2.20046 4.76562 2.20046 4.63282 2.27923 4.5C2.6891 4.0887 3.18137 3.94416 3.75606 4.06641C3.98274 4.12605 4.18359 4.23152 4.35861 4.38281C5.52873 3.39616 6.69444 2.40398 7.85575 1.40625C7.6946 1.01431 7.71823 0.631498 7.92664 0.257812C7.99824 0.1595 8.08094 0.0735623 8.17475 0Z"
        fill="#757575"
      />
    </svg>
  ),
  taskchatIcon: (props) => (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2.5" cy="2.5" r="2.5" fill="#757575" />
      <circle cx="2.5" cy="10.5" r="2.5" fill="#757575" />
      <circle cx="10.5" cy="2.5" r="2.5" fill="#757575" />
      <circle cx="10.5" cy="10.5" r="2.5" fill="#757575" />
    </svg>
  ),
  aichatIcon: (props) => (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 3.33267C8.93 3.82 10.18 5.07067 10.666 6.66667C11.1547 5.07 12.4047 3.82067 14 3.33333C12.4047 2.846 11.1547 1.59667 10.666 0C10.18 1.596 8.93 2.84533 7.33333 3.33267ZM12 7.99933C12.958 8.29133 13.708 9.042 13.9993 10C14.2927 9.042 15.0427 8.292 16 8C15.0427 7.70733 14.2927 6.958 13.9993 6C13.708 6.95733 12.958 7.70733 12 7.99933ZM8 11.6667C8.79867 11.91 9.42333 12.5353 9.666 13.3333C9.91 12.5347 10.5353 11.91 11.3333 11.6667C10.5353 11.4227 9.91067 10.7987 9.666 10C9.42333 10.798 8.79867 11.4227 8 11.6667ZM3.99933 3.33333C3.416 5.24867 1.914 6.75 0 7.334C1.91733 7.92067 3.416 9.41933 4.00267 11.3367C4.586 9.42067 6.088 7.92067 8 7.334C6.088 6.75133 4.586 5.24933 3.99933 3.33333Z"
        fill="#757575"
      />
    </svg>
  ),
  v3_search: (props) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6467 11.354C9.66066 12.1793 8.39066 12.6773 7.00599 12.6773C3.87466 12.6773 1.33333 10.136 1.33333 7.00531C1.33333 3.87465 3.87466 1.33331 7.00599 1.33331C10.136 1.33331 12.678 3.87465 12.678 7.00531C12.678 8.39065 12.18 9.66131 11.3547 10.646L14.5207 13.8126C14.618 13.91 14.6667 14.038 14.6667 14.1666C14.6667 14.558 14.3087 14.6666 14.1667 14.6666C14.0387 14.6666 13.9107 14.618 13.8127 14.52L10.6467 11.354ZM7.00599 2.33398C4.42733 2.33398 2.33466 4.42731 2.33466 7.00531C2.33466 9.58331 4.42733 11.6766 7.00599 11.6766C9.58333 11.6766 11.6773 9.58331 11.6773 7.00531C11.6773 4.42731 9.58333 2.33398 7.00599 2.33398Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.2"
      />
    </svg>
  ),
  uploadimgIcon: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.00781 0C4.15312 0 4.22813 0.028125 4.32656 0.126563C4.43906 0.239063 4.4625 0.314062 4.50469 0.65625C4.52812 0.876562 4.57969 1.17188 4.62187 1.3125C4.66406 1.45312 4.77188 1.71563 4.86563 1.89844C4.97813 2.11406 5.15625 2.34844 5.39062 2.58281C5.59688 2.78906 5.86875 3.00469 6.04688 3.10312C6.21562 3.19687 6.45937 3.30469 6.58594 3.34688C6.71719 3.38906 7.02188 3.45 7.27031 3.47812C7.59844 3.525 7.74844 3.5625 7.82344 3.63281C7.87969 3.68438 7.94531 3.79688 7.96875 3.88125C8.00625 3.99375 7.99687 4.07344 7.94531 4.19531C7.90781 4.28438 7.81875 4.3875 7.74375 4.425C7.67344 4.45781 7.46719 4.5 7.28906 4.51406C7.11094 4.53281 6.81094 4.58906 6.63281 4.64531C6.45469 4.69687 6.16875 4.82344 6 4.92188C5.83125 5.02031 5.57812 5.2125 5.4375 5.34844C5.29688 5.48906 5.10469 5.70937 5.02031 5.83594C4.93125 5.9625 4.80938 6.17812 4.75313 6.30469C4.69688 6.43125 4.61719 6.69375 4.575 6.88125C4.53281 7.06406 4.5 7.30781 4.5 7.41562C4.5 7.53281 4.4625 7.67812 4.40625 7.76719C4.34531 7.86562 4.25156 7.94063 4.14844 7.96875C4.02187 8.00625 3.94688 7.99687 3.82031 7.94531C3.73125 7.90781 3.62812 7.82812 3.59062 7.76719C3.55312 7.71094 3.51094 7.51406 3.49219 7.33594C3.47813 7.15781 3.44063 6.91406 3.4125 6.79688C3.38438 6.67969 3.27656 6.40781 3.17344 6.1875C3.01875 5.87344 2.90156 5.70937 2.60156 5.41406C2.30625 5.11406 2.14219 4.99688 1.82812 4.84219C1.60781 4.73906 1.32187 4.62656 1.19531 4.59375C1.06406 4.56563 0.801562 4.51875 0.609375 4.5C0.31875 4.4625 0.234375 4.43438 0.126563 4.32656C0.028125 4.22344 0 4.15312 0 4.00781C0 3.90469 0.0375 3.77813 0.084375 3.72188C0.126562 3.67031 0.20625 3.60469 0.257812 3.57656C0.309375 3.54844 0.478125 3.51562 0.632812 3.49687C0.7875 3.47812 1.02188 3.44063 1.14844 3.4125C1.27969 3.38438 1.51875 3.3 1.6875 3.225C1.85625 3.15 2.11875 2.99531 2.27344 2.8875C2.42812 2.775 2.625 2.60156 2.71406 2.50313C2.80313 2.40469 2.94844 2.20312 3.0375 2.0625C3.13125 1.92188 3.24844 1.67813 3.30937 1.52344C3.36562 1.36875 3.43594 1.06406 3.46406 0.84375C3.49219 0.623438 3.52969 0.398437 3.53906 0.3375C3.55312 0.28125 3.61875 0.182812 3.68906 0.117188C3.78281 0.0328125 3.87656 0 4.00781 0ZM14.1797 1.5C20.6859 1.5 22.2891 1.51406 22.4766 1.56094C22.6031 1.59844 22.8234 1.6875 22.9641 1.7625C23.1 1.8375 23.3156 2.00156 23.4375 2.13281C23.5594 2.25938 23.7094 2.47031 23.775 2.60156C23.8406 2.72813 23.9203 2.94844 23.9484 3.07969C23.9859 3.25781 24 5.95312 24 12.75C24 19.5469 23.9859 22.2422 23.9484 22.4203C23.9203 22.5516 23.8406 22.7672 23.775 22.8984C23.7094 23.025 23.5594 23.2359 23.4422 23.3625C23.325 23.4844 23.1422 23.6391 23.0391 23.7C22.9359 23.7609 22.7344 23.8547 22.5938 23.9062C22.3359 24 22.2656 24 12.75 24C3.23438 24 3.16406 24 2.90625 23.9062C2.76562 23.8547 2.56406 23.7609 2.46094 23.7C2.35781 23.6391 2.175 23.4844 2.05781 23.3625C1.94063 23.2359 1.79531 23.0391 1.73438 22.9219C1.67344 22.8047 1.59844 22.6031 1.56563 22.4766C1.51406 22.2844 1.5 20.7563 1.5 14.1891C1.5 6.60938 1.50469 6.13125 1.57969 6C1.62656 5.925 1.71094 5.84062 1.76719 5.8125C1.82813 5.78906 1.95 5.76562 2.03906 5.76562C2.16094 5.76562 2.24062 5.80312 2.48438 6.04688V10.8609C2.48438 13.5141 2.49844 15.6984 2.51719 15.7172C2.54063 15.7359 4.00781 14.3016 5.78906 12.525C8.55 9.76875 9.07031 9.26719 9.32812 9.12656C9.49687 9.0375 9.75 8.925 9.89062 8.87812C10.0875 8.8125 10.2891 8.78906 10.7344 8.78906C11.2312 8.78906 11.3719 8.80781 11.6719 8.90625C11.8641 8.96719 12.15 9.10313 12.3047 9.20156C12.4922 9.32344 13.5938 10.3875 18.4922 15.2812L23.0156 10.7578V7.11094C23.0156 4.45312 23.0016 3.40781 22.9594 3.24375C22.9219 3.08906 22.8422 2.9625 22.6922 2.80781C22.5375 2.65781 22.4109 2.57812 22.2562 2.54063C22.0875 2.49844 20.0578 2.48438 6.04688 2.48438L5.90625 2.34375C5.80312 2.24062 5.76562 2.16094 5.76562 2.03906C5.76562 1.95 5.78906 1.82813 5.8125 1.76719C5.84062 1.71094 5.92031 1.62656 5.99063 1.58437C6.10781 1.50937 6.62812 1.50469 14.1797 1.5ZM3.82031 2.70469C3.72187 2.85469 3.49219 3.12656 3.30937 3.30469C3.12656 3.4875 2.85 3.71719 2.69531 3.81563C2.54063 3.91406 2.4375 4.00781 2.46094 4.02656C2.48906 4.04531 2.62969 4.14375 2.78438 4.24219C2.93438 4.34531 3.21094 4.58906 3.39375 4.78125C3.58125 4.97344 3.7875 5.23125 3.85781 5.35312L3.98438 5.57812C4.28438 5.12344 4.51406 4.85156 4.68281 4.68281C4.85156 4.51406 5.12344 4.28906 5.28281 4.19063L5.56875 4.00781C5.12344 3.70781 4.85625 3.48281 4.69219 3.32344C4.52812 3.15938 4.30312 2.89219 4.19531 2.72813L3.99844 2.4375L3.82031 2.70469ZM9.9375 9.94219C9.65156 10.0688 9.40313 10.3078 6.06094 13.65L2.48438 17.2219C2.48438 21.3234 2.50313 22.0922 2.54063 22.2516C2.58281 22.4109 2.65781 22.5328 2.8125 22.6875C2.9625 22.8422 3.08906 22.9172 3.24844 22.9547C3.41719 22.9969 5.7375 23.0109 12.75 23.0109C19.7672 23.0109 22.0875 22.9969 22.2562 22.9547C22.4156 22.9172 22.5375 22.8422 22.6922 22.6875C22.8422 22.5328 22.9219 22.4109 22.9594 22.2516C22.9922 22.1297 23.0156 21.8438 23.0156 21.6188V21.2062C14.0297 12.2297 11.85 10.0875 11.7188 10.0125C11.6062 9.94688 11.3813 9.85781 11.2266 9.82031C11.0719 9.77812 10.8422 9.75 10.7109 9.75469C10.5844 9.75469 10.425 9.76875 10.3594 9.78281C10.2984 9.79219 10.1062 9.86719 9.9375 9.94219ZM19.2188 16.0031C22.1063 18.8953 22.9641 19.7203 22.9828 19.6969C23.0016 19.6781 23.0203 18 23.0203 15.9703C23.0156 13.9406 23.0016 12.2766 22.9828 12.2766C22.9641 12.2766 22.1062 13.1156 21.0844 14.1422L19.2188 16.0031ZM17.9766 3.51094C18.1828 3.51094 18.4781 3.54375 18.6328 3.58125C18.7875 3.62344 19.0406 3.72187 19.1953 3.80625C19.35 3.89062 19.6031 4.08281 19.7578 4.2375C19.9125 4.39219 20.1047 4.64531 20.1891 4.8C20.2688 4.95469 20.3719 5.20781 20.4094 5.3625C20.4516 5.51719 20.4844 5.80313 20.4844 5.99531C20.4844 6.1875 20.4516 6.47344 20.4094 6.62812C20.3719 6.78281 20.2688 7.03594 20.1891 7.19062C20.1047 7.34531 19.9125 7.59844 19.7578 7.75312C19.6031 7.90781 19.35 8.1 19.1953 8.18438C19.0406 8.26406 18.7875 8.36719 18.6328 8.40469C18.4781 8.44688 18.1922 8.47969 18 8.47969C17.8031 8.47969 17.5219 8.44688 17.3672 8.40469C17.2125 8.36719 16.9594 8.26406 16.8047 8.18438C16.65 8.1 16.3969 7.90781 16.2422 7.75312C16.0875 7.59844 15.8906 7.34531 15.8109 7.19062C15.7266 7.03594 15.6281 6.78281 15.5859 6.62812C15.5484 6.47344 15.5156 6.1875 15.5156 5.99531C15.5156 5.80313 15.5484 5.51719 15.5859 5.3625C15.6281 5.20781 15.7266 4.95469 15.8109 4.8C15.8906 4.64531 16.0875 4.39219 16.2422 4.2375C16.3969 4.08281 16.65 3.88594 16.8047 3.80625C16.9594 3.72187 17.1984 3.62344 17.3438 3.58594C17.4844 3.54844 17.7703 3.51563 17.9766 3.51094ZM17.3203 4.65938C17.2172 4.71094 17.0484 4.8375 16.9406 4.94063C16.8375 5.04375 16.7016 5.23125 16.6406 5.3625C16.5469 5.55469 16.5281 5.67188 16.5234 5.99531C16.5234 6.36094 16.5375 6.41719 16.6875 6.69375C16.7766 6.85781 16.9125 7.04531 16.9922 7.11094C17.0672 7.17187 17.2359 7.27969 17.3672 7.34531C17.5641 7.44844 17.6625 7.46719 18 7.46719C18.3375 7.46719 18.4312 7.44844 18.6328 7.34531C18.7594 7.27969 18.9281 7.17187 19.0078 7.11094C19.0828 7.04531 19.2188 6.85781 19.3125 6.69375C19.4625 6.41719 19.4719 6.36094 19.4719 5.99531C19.4719 5.65781 19.4531 5.55938 19.35 5.3625C19.2844 5.23125 19.1766 5.0625 19.1109 4.9875C19.05 4.90781 18.8719 4.77656 18.7219 4.69219C18.5062 4.575 18.3703 4.5375 18.1172 4.51875C17.9344 4.50938 17.7234 4.51406 17.6484 4.5375C17.5688 4.55625 17.4234 4.6125 17.3203 4.65938Z"
        fill="#1D1D1D"
      />
    </svg>
  ),
  vectorfilev3: (props) => (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2833 0C19.6385 0 21.5509 1.91236 21.5509 4.26764C21.5509 4.69855 21.4931 6.12655 20.2473 7.33636L11.0127 16.5709C10.3625 17.3029 8.7 17.9662 7.41382 16.6789C6.12873 15.3949 6.77455 13.7498 7.50982 13.0898L12.3196 8.28L13.0909 9.05127L9.63927 12.5018L9.65455 12.5051L8.11527 14.0465L8.11964 14.0498C7.06145 15.3055 8.79382 17.2462 10.2764 15.7647L19.4215 6.61855C20.1371 5.90727 20.4469 5.09891 20.4469 4.26764C20.4469 2.52109 19.0298 1.104 17.2833 1.104C16.4291 1.104 15.6524 1.44327 15.0818 1.99636L15.0785 1.99309C14.4535 2.61818 2.53091 14.532 2.496 14.568L2.49382 14.5658C1.62655 15.4516 1.09091 16.6636 1.09091 18C1.09091 20.7087 3.29127 22.9091 6 22.9091C6.70909 22.9091 8.00727 22.9167 9.84 21.0895L21.0469 9.88909L21.8182 10.6604L10.3887 22.0898C9.29345 23.2647 7.73236 24 6 24C2.68909 24 0 21.3109 0 18C0 16.2796 0.726545 14.7273 1.88836 13.632C13.5262 1.99527 13.7084 1.80764 14.2102 1.308C14.5124 1.00473 15.5356 0 17.2833 0Z"
        fill="#C4C4C4"
      />
    </svg>
  ),
  tooglesidebar: (props) => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2277 20.9945H3.77228C3.03748 20.9931 2.33321 20.7007 1.81363 20.1814C1.29405 19.6621 1.0015 18.9582 1 18.2238V3.77657C1.0015 3.04219 1.29405 2.33832 1.81363 1.81903C2.33321 1.29975 3.03748 1.00735 3.77228 1.00586H18.2277C18.9625 1.00735 19.6668 1.29975 20.1864 1.81903C20.7059 2.33832 20.9985 3.04219 21 3.77657V18.2238C20.9985 18.9582 20.7059 19.6621 20.1864 20.1814C19.6668 20.7007 18.9625 20.9931 18.2277 20.9945ZM3.77228 2.13676C3.33713 2.13676 2.9198 2.30953 2.6121 2.61705C2.3044 2.92457 2.13154 3.34166 2.13154 3.77657V18.2238C2.13154 18.6587 2.3044 19.0758 2.6121 19.3834C2.9198 19.6909 3.33713 19.8636 3.77228 19.8636H18.2277C18.6629 19.8636 19.0802 19.6909 19.3879 19.3834C19.6956 19.0758 19.8685 18.6587 19.8685 18.2238V3.77657C19.8685 3.34166 19.6956 2.92457 19.3879 2.61705C19.0802 2.30953 18.6629 2.13676 18.2277 2.13676H3.77228Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.2"
      />
      <path
        d="M7.32236 20.5C7.30483 20.5 7.28807 20.493 7.27576 20.4807C7.26345 20.4684 7.25659 20.4518 7.25659 20.4345V1.56545C7.25659 1.54818 7.26345 1.53157 7.27576 1.51927C7.28807 1.50696 7.30483 1.5 7.32236 1.5C7.3399 1.5 7.35666 1.50696 7.36897 1.51927C7.38127 1.53157 7.38813 1.54818 7.38813 1.56545V20.4345C7.38813 20.4518 7.38127 20.4684 7.36897 20.4807C7.35665 20.493 7.33989 20.5 7.32236 20.5Z"
        fill="#757575"
        stroke="#757575"
      />
    </svg>
  ),
  spinner: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="4"
        stroke={props.color ? props.color : "#000"}
        stroke-linecap="round"
        stroke-dasharray="90,150"
        stroke-dashoffset="0"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="1s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  ),
  newchatIcon: (props) => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5238 8.41497C20.4104 8.41497 20.3016 8.46002 20.2215 8.54021C20.1413 8.6204 20.0962 8.72916 20.0962 8.84257V19.0466C20.0962 19.3199 19.9877 19.5819 19.7945 19.7751C19.6013 19.9682 19.3393 20.0768 19.0661 20.0768H2.89018C2.61698 20.0768 2.35496 19.9682 2.16178 19.7751C1.96859 19.5819 1.86006 19.3199 1.86006 19.0466V2.89018C1.86006 2.61698 1.96859 2.35496 2.16178 2.16178C2.35496 1.96859 2.61698 1.86006 2.89018 1.86006H13.0943C13.2083 1.86006 13.3177 1.81475 13.3983 1.73411C13.479 1.65346 13.5243 1.54408 13.5243 1.43003C13.5243 1.31598 13.479 1.2066 13.3983 1.12595C13.3177 1.04531 13.2083 1 13.0943 1H2.89018C2.38888 1 1.9081 1.19914 1.55362 1.55362C1.19914 1.9081 1 2.38888 1 2.89018V19.0612C1 19.5625 1.19914 20.0433 1.55362 20.3978C1.9081 20.7523 2.38888 20.9514 2.89018 20.9514H19.0612C19.5625 20.9514 20.0433 20.7523 20.3978 20.3978C20.7523 20.0433 20.9514 19.5625 20.9514 19.0612V8.85714C20.9534 8.79977 20.9438 8.7426 20.9231 8.68903C20.9025 8.63545 20.8713 8.58658 20.8314 8.54532C20.7915 8.50405 20.7437 8.47125 20.6909 8.44885C20.638 8.42646 20.5812 8.41493 20.5238 8.41497Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.5"
      />
      <path
        d="M18.9932 1.10945L18.9831 1.10847L18.973 1.10954C18.71 1.13748 18.4551 1.21744 18.2233 1.34478C17.9931 1.4712 17.7902 1.64181 17.6261 1.8468L10.7253 8.7476L10.725 8.74731L10.7192 8.7543L10.695 8.78329C10.695 8.78331 10.695 8.78334 10.695 8.78337C10.5923 8.90603 10.4541 9.15839 10.303 9.46716C10.1499 9.77996 9.97834 10.162 9.80952 10.5528C9.47203 11.3342 9.14381 12.1548 8.99289 12.5369C8.95318 12.6331 8.94281 12.7389 8.96309 12.841C8.98343 12.9434 9.03369 13.0375 9.10751 13.1113C9.18133 13.1851 9.27538 13.2354 9.37777 13.2557C9.47987 13.276 9.58568 13.2656 9.68189 13.2259C10.0641 13.075 10.8834 12.7467 11.6642 12.4093C12.0547 12.2404 12.4366 12.0689 12.7496 11.9158C13.0587 11.7647 13.3114 11.6265 13.4351 11.5241L13.4353 11.5239L13.4645 11.4996L13.4648 11.4999L13.4712 11.4934L20.3677 4.58725C20.7441 4.27634 21.002 3.84537 21.0981 3.36667L21.1003 3.35589L21.1001 3.34489C21.094 3.05503 21.025 2.76995 20.8978 2.50941C20.7721 2.25191 20.5926 2.02446 20.3714 1.84244C20.202 1.63727 19.9942 1.46712 19.7595 1.34157C19.5219 1.21443 19.2615 1.13554 18.9932 1.10945ZM19.6312 3.82719L19.6307 3.82664L19.6223 3.83507L12.7427 10.7147C11.9933 11.1121 11.2216 11.4656 10.4313 11.7735C10.742 10.9829 11.0986 10.211 11.4991 9.46169L18.3836 2.59172L18.3837 2.59165C18.5426 2.43272 18.666 2.32521 18.7665 2.25779C18.8673 2.19025 18.9363 2.16904 18.9884 2.16904C19.0408 2.16904 19.1248 2.19521 19.2398 2.26689C19.3524 2.33701 19.4849 2.44458 19.632 2.59165C19.7802 2.73985 19.8959 2.87597 19.9698 2.99333C20.0432 3.10992 20.064 3.19012 20.0575 3.23888C19.9728 3.47073 19.8252 3.67448 19.6312 3.82719Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.2"
      />
    </svg>
  ),
  pencilblack: (props) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_715_7299)">
        <path
          d="M1.5 10.3501L0 15.0001L4.65 13.5001L1.5 10.3501Z"
          fill="#757575"
        />
        <path
          d="M9.87192 1.9538L2.5535 9.27222L5.73543 12.4541L13.0538 5.13572L9.87192 1.9538Z"
          fill="#757575"
        />
        <path
          d="M14.775 2.325L12.675 0.225C12.375 -0.075 11.925 -0.075 11.625 0.225L10.95 0.9L14.1 4.05L14.775 3.375C15.075 3.075 15.075 2.625 14.775 2.325Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_715_7299">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  magicstar: (props) => (
    <svg
      width="23"
      height="20"
      viewBox="0 0 23 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5417 4.79071C12.8369 5.49125 14.6337 7.28908 15.3324 9.58333C16.0348 7.28813 17.8317 5.49221 20.125 4.79167C17.8317 4.09113 16.0348 2.29521 15.3324 0C14.6337 2.29425 12.8369 4.09017 10.5417 4.79071ZM17.25 11.499C18.6271 11.9188 19.7052 12.9979 20.124 14.375C20.5457 12.9979 21.6238 11.9198 23 11.5C21.6238 11.0793 20.5457 10.0021 20.124 8.625C19.7052 10.0012 18.6271 11.0793 17.25 11.499ZM11.5 16.7708C12.6481 17.1206 13.546 18.0195 13.8949 19.1667C14.2456 18.0186 15.1445 17.1206 16.2917 16.7708C15.1445 16.4201 14.2466 15.5231 13.8949 14.375C13.546 15.5221 12.6481 16.4201 11.5 16.7708ZM5.74904 4.79167C4.9105 7.54496 2.75138 9.70312 0 10.5426C2.75617 11.386 4.9105 13.5403 5.75383 16.2965C6.59238 13.5422 8.7515 11.386 11.5 10.5426C8.7515 9.70504 6.59238 7.54592 5.74904 4.79167Z"
        fill="#1D1D1D"
      />
    </svg>
  ),
  shared: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
    >
      <path
        d="M2.7 6.44314C3.69281 6.44314 4.5 5.6176 4.5 4.60223C4.5 3.58685 3.69281 2.76132 2.7 2.76132C1.70719 2.76132 0.9 3.58685 0.9 4.60223C0.9 5.6176 1.70719 6.44314 2.7 6.44314ZM15.3 6.44314C16.2928 6.44314 17.1 5.6176 17.1 4.60223C17.1 3.58685 16.2928 2.76132 15.3 2.76132C14.3072 2.76132 13.5 3.58685 13.5 4.60223C13.5 5.6176 14.3072 6.44314 15.3 6.44314ZM16.2 7.36359H14.4C13.905 7.36359 13.4578 7.56782 13.1316 7.89861C14.265 8.5343 15.0694 9.68199 15.2437 11.0454H17.1C17.5978 11.0454 18 10.6341 18 10.125V9.2045C18 8.18912 17.1928 7.36359 16.2 7.36359ZM9 7.36359C10.7409 7.36359 12.15 5.92251 12.15 4.142C12.15 2.3615 10.7409 0.92041 9 0.92041C7.25906 0.92041 5.85 2.3615 5.85 4.142C5.85 5.92251 7.25906 7.36359 9 7.36359ZM11.16 8.28405H10.9266C10.3416 8.57169 9.69187 8.74427 9 8.74427C8.30812 8.74427 7.66125 8.57169 7.07344 8.28405H6.84C5.05125 8.28405 3.6 9.76828 3.6 11.5977V12.4261C3.6 13.1883 4.20469 13.8068 4.95 13.8068H13.05C13.7953 13.8068 14.4 13.1883 14.4 12.4261V11.5977C14.4 9.76828 12.9487 8.28405 11.16 8.28405ZM4.86844 7.89861C4.54219 7.56782 4.095 7.36359 3.6 7.36359H1.8C0.807187 7.36359 0 8.18912 0 9.2045V10.125C0 10.6341 0.402187 11.0454 0.9 11.0454H2.75344C2.93062 9.68199 3.735 8.5343 4.86844 7.89861Z"
        fill="#92A5AF"
      />
    </svg>
  ),
  filledStar: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M7.54894 0.927052C7.8483 0.0057416 9.1517 0.00573945 9.45106 0.92705L10.6329 4.56434C10.7668 4.97636 11.1507 5.25532 11.5839 5.25532H15.4084C16.3771 5.25532 16.7799 6.49494 15.9962 7.06434L12.9021 9.31231C12.5516 9.56695 12.405 10.0183 12.5389 10.4303L13.7207 14.0676C14.02 14.9889 12.9656 15.7551 12.1818 15.1857L9.08779 12.9377C8.7373 12.6831 8.2627 12.6831 7.91222 12.9377L4.81815 15.1857C4.03444 15.7551 2.97996 14.9889 3.27931 14.0676L4.46114 10.4303C4.59501 10.0183 4.44835 9.56695 4.09787 9.31231L1.00381 7.06434C0.220092 6.49494 0.622867 5.25532 1.59159 5.25532H5.41606C5.84929 5.25532 6.23324 4.97636 6.36712 4.56434L7.54894 0.927052Z"
        fill="#F6CF00"
      />
    </svg>
  ),
  star: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M8.02447 1.08156C8.17415 0.620902 8.82585 0.620907 8.97553 1.08156L10.1574 4.71885C10.3582 5.33688 10.9341 5.75532 11.5839 5.75532H15.4084C15.8928 5.75532 16.0942 6.37513 15.7023 6.65983L12.6082 8.9078C12.0825 9.28976 11.8625 9.96681 12.0633 10.5848L13.2452 14.2221C13.3948 14.6828 12.8676 15.0659 12.4757 14.7812L9.38168 12.5332C8.85595 12.1512 8.14405 12.1512 7.61832 12.5332L4.52426 14.7812C4.1324 15.0659 3.60516 14.6828 3.75484 14.2221L4.93667 10.5848C5.13748 9.96682 4.91749 9.28976 4.39176 8.9078L1.2977 6.65983C0.90584 6.37513 1.10723 5.75532 1.59159 5.75532H5.41606C6.0659 5.75532 6.64183 5.33688 6.84265 4.71885L8.02447 1.08156Z"
        stroke="#92A5AF"
      />
    </svg>
  ),
  pencil: (props) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_426_7269)">
        <path d="M2 13.7998L0 19.9998L6.2 17.9998L2 13.7998Z" fill="#FCFCFC" />
        <path
          d="M13.1627 2.6049L3.40479 12.3628L7.64736 16.6054L17.4053 6.84747L13.1627 2.6049Z"
          fill="#FCFCFC"
        />
        <path
          d="M19.7001 3.1L16.9001 0.3C16.5001 -0.1 15.9001 -0.1 15.5001 0.3L14.6001 1.2L18.8001 5.4L19.7001 4.5C20.1001 4.1 20.1001 3.5 19.7001 3.1Z"
          fill="#FCFCFC"
        />
      </g>
      <defs>
        <clipPath id="clip0_426_7269">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  attach: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1.816 15.556v.002c0 1.502.584 2.912 1.646 3.972s2.472 1.647 3.974 1.647a5.58 5.58 0 0 0 3.972-1.645l9.547-9.548c.769-.768 1.147-1.767 1.058-2.817-.079-.968-.548-1.927-1.319-2.698-1.594-1.592-4.068-1.711-5.517-.262l-7.916 7.915c-.881.881-.792 2.25.214 3.261.959.958 2.423 1.053 3.263.215l5.511-5.512c.28-.28.267-.722.053-.936l-.244-.244c-.191-.191-.567-.349-.957.04l-5.506 5.506c-.18.18-.635.127-.976-.214-.098-.097-.576-.613-.213-.973l7.915-7.917c.818-.817 2.267-.699 3.23.262.5.501.802 1.1.849 1.685.051.573-.156 1.111-.589 1.543l-9.547 9.549a3.97 3.97 0 0 1-2.829 1.171 3.975 3.975 0 0 1-2.83-1.173 3.973 3.973 0 0 1-1.172-2.828c0-1.071.415-2.076 1.172-2.83l7.209-7.211c.157-.157.264-.579.028-.814L11.5 4.36a.572.572 0 0 0-.834.018l-7.205 7.207a5.577 5.577 0 0 0-1.645 3.971z"
      ></path>
    </svg>
  ),
  dobuleTickWhite: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        d="M0 5.38285L3.08199 9.5L9 1.61716L8.15037 0.5L3.08199 7.24996L0.83786 4.25782L0 5.38285Z"
        fill="#FCFCFC"
      />
      <path
        d="M7 5.38285L10.08199 9.5L16 1.61716L15.15037 0.5L10.08199 7.24996L7.83786 4.25782L7 5.38285Z"
        fill="#FCFCFC"
      />
    </svg>
  ),
  close: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="14"
      height="14"
      viewBox="0,0,256,256"
    >
      <g
        fill-opacity="0.8"
        fill="#000000"
        fillRule="nonzero"
        stroke="none"
        stroke-width="1"
        stroke-linecap="butt"
        stroke-linejoin="miter"
        stroke-miterlimit="10"
        stroke-dasharray=""
        stroke-dashoffset="0"
        font-family="none"
        font-weight="none"
        font-size="none"
        text-anchor="none"
      >
        <g transform="scale(5.12,5.12)">
          <path d="M9.15625,6.3125l-2.84375,2.84375l15.84375,15.84375l-15.9375,15.96875l2.8125,2.8125l15.96875,-15.9375l15.9375,15.9375l2.84375,-2.84375l-15.9375,-15.9375l15.84375,-15.84375l-2.84375,-2.84375l-15.84375,15.84375z"></path>
        </g>
      </g>
    </svg>
  ),
  copy: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_128_107)">
        <path
          d="M18.3333 5V18.3333H5V5H18.3333ZM20 3.33333H3.33333V20H20V3.33333ZM0 17.5V0H17.5V1.66667H1.66667V17.5H0Z"
          fill="#0D0D0D"
        />
      </g>
      <defs>
        <clipPath id="clip0_128_107">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  sendChat: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="35"
      viewBox="0 0 41 35"
      fill="none"
    >
      <rect x="0.532715" width="40.3338" height="35" rx="17.5" fill="#D9D9D9" />
      <path
        d="M21.7418 7.22609C21.3933 6.87755 20.8282 6.87755 20.4796 7.22609L14.7999 12.9058C14.4514 13.2544 14.4514 13.8195 14.7999 14.168C15.1484 14.5165 15.7135 14.5165 16.0621 14.168L21.1107 9.11934L26.1594 14.168C26.5079 14.5165 27.073 14.5165 27.4215 14.168C27.7701 13.8195 27.7701 13.2544 27.4215 12.9058L21.7418 7.22609ZM22.0032 27.1429L22.0032 7.85717L20.2182 7.85717L20.2182 27.1429L22.0032 27.1429Z"
        fill="#A9A8A8"
      />
    </svg>
  ),
  cogSm: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M6.56484 0L5.62968 2.22569C5.44264 2.2818 5.27431 2.37531 5.10598 2.46883L2.8803 1.53367L1.53367 2.8803L2.46883 5.10598C2.37531 5.29302 2.3005 5.44264 2.22569 5.62968L0 6.56484V8.43516L2.22569 9.37032C2.3005 9.55736 2.37531 9.70698 2.46883 9.89401L1.53367 12.1197L2.8803 13.4663L5.10598 12.5312C5.27431 12.606 5.44264 12.6995 5.62968 12.7743L6.56484 15H8.43516L9.37032 12.7743C9.53865 12.6995 9.72569 12.6247 9.89402 12.5312L12.1197 13.4663L13.4663 12.1197L12.5312 9.89401C12.606 9.72569 12.6995 9.53865 12.7743 9.37032L15 8.43516V6.56484L12.7743 5.62968C12.7182 5.46135 12.6247 5.27431 12.5312 5.10598L13.4663 2.8803L12.1197 1.53367L9.89402 2.46883C9.72569 2.39402 9.53865 2.3005 9.37032 2.22569L8.43516 0L6.56484 0ZM7.5 4.67581C9.05237 4.67581 10.3055 5.92893 10.3055 7.4813C10.3055 9.03367 9.05237 10.2868 7.5 10.2868C5.94763 10.2868 4.69451 9.03367 4.69451 7.4813C4.69451 5.92893 5.94763 4.67581 7.5 4.67581Z"
        fill="#92A5AF"
      />
    </svg>
  ),
  cog: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_55_324)">
        <path
          d="M8.74998 0L7.49998 2.975C7.24998 3.05 7.02498 3.175 6.79998 3.3L3.82498 2.05L2.02498 3.85L3.27498 6.825C3.14998 7.075 3.04998 7.275 2.94998 7.525L-0.0250244 8.775V11.275L2.94998 12.525C3.04998 12.775 3.14998 12.975 3.27498 13.225L2.02498 16.2L3.82498 18L6.79998 16.75C7.02498 16.85 7.24998 16.975 7.49998 17.075L8.74998 20.05H11.25L12.5 17.075C12.725 16.975 12.975 16.875 13.2 16.75L16.175 18L17.975 16.2L16.725 13.225C16.825 13 16.95 12.75 17.05 12.525L20.025 11.275V8.775L17.05 7.525C16.975 7.3 16.85 7.05 16.725 6.825L17.975 3.85L16.175 2.05L13.2 3.3C12.975 3.2 12.725 3.075 12.5 2.975L11.25 0L8.74998 0ZM9.99998 6.25C12.075 6.25 13.75 7.925 13.75 10C13.75 12.075 12.075 13.75 9.99998 13.75C7.92498 13.75 6.24998 12.075 6.24998 10C6.24998 7.925 7.92498 6.25 9.99998 6.25Z"
          fill="#92A5AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_55_324">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  user: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <g clip-path="url(#clip0_99_412)">
        <path
          d="M6.94065 6.032C5.79431 5.76733 4.72731 5.53533 5.24398 4.55933C6.81731 1.58867 5.66098 0 3.99998 0C2.30598 0 1.17865 1.64967 2.75598 4.55933C3.28831 5.541 2.18098 5.773 1.05931 6.032C0.0349789 6.26867 -0.00335443 6.77733 -2.10995e-05 7.66667L0.00131223 8H7.99798L7.99931 7.677C8.00331 6.781 7.96865 6.26967 6.94065 6.032Z"
          fill="#5D737E"
        />
      </g>
      <defs>
        <clipPath id="clip0_99_412">
          <rect width="8" height="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  exp_dots: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <circle cx="2.94847" cy="2.94847" r="2.94847" fill="white" />
      <circle cx="2.94847" cy="11.0516" r="2.94847" fill="white" />
      <circle cx="11.0516" cy="2.94847" r="2.94847" fill="white" />
      <circle cx="11.0516" cy="11.0516" r="2.94847" fill="white" />
    </svg>
  ),
  boxes: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="currentColor"
    >
      <rect
        x="2"
        y="2"
        width="10"
        height="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="12"
        y="2"
        width="10"
        height="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="2"
        y="12"
        width="10"
        height="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="12"
        y="12"
        width="10"
        height="10"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
    </svg>
  ),
  attachCamera: (props) => (
    <span
      data-testid="attach-camera"
      data-icon="attach-camera"
      className="_1SWzr"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 53 53"
        width="53"
        height="53"
        {...props}
      >
        <defs>
          <circle id="camera-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
        </defs>
        <clipPath id="camera-SVGID_2_">
          <use xlinkHref="#camera-SVGID_1_" overflow="visible"></use>
        </clipPath>
        <g clipPath="url(#camera-SVGID_2_)">
          <path
            fill="#D3396D"
            d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
          ></path>
          <path
            fill="#EC407A"
            d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
          ></path>
          <path fill="#D3396D" d="M17 24.5h15v9H17z"></path>
        </g>
        <g fill="#F5F5F5">
          <path
            id="svg-camera"
            d="M27.795 17a3 3 0 0 1 2.405 1.206l.3.403a3 3 0 0 0 2.405 1.206H34.2a2.8 2.8 0 0 1 2.8 2.8V32a4 4 0 0 1-4 4H20a4 4 0 0 1-4-4v-9.385a2.8 2.8 0 0 1 2.8-2.8h1.295a3 3 0 0 0 2.405-1.206l.3-.403A3 3 0 0 1 25.205 17h2.59zM26.5 22.25a5.25 5.25 0 1 0 .001 10.501A5.25 5.25 0 0 0 26.5 22.25zm0 1.75a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7z"
          ></path>
        </g>
      </svg>
    </span>
  ),
  attachContacts: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="contact-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="contact-SVGID_2_">
        <use xlinkHref="#contact-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#contact-SVGID_2_)">
        <path
          fill="#0795DC"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#0EABF4"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-contact"
          d="M26.5 26.5A4.5 4.5 0 0 0 31 22a4.5 4.5 0 0 0-4.5-4.5A4.5 4.5 0 0 0 22 22a4.5 4.5 0 0 0 4.5 4.5zm0 2.25c-3.004 0-9 1.508-9 4.5v1.125c0 .619.506 1.125 1.125 1.125h15.75c.619 0 1.125-.506 1.125-1.125V33.25c0-2.992-5.996-4.5-9-4.5z"
        ></path>
      </g>
    </svg>
  ),
  attachDocument: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="document-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="document-SVGID_2_">
        <use xlinkHref="#document-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#document-SVGID_2_)">
        <path
          fill="#5157AE"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#5F66CD"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-document"
          d="M29.09 17.09c-.38-.38-.89-.59-1.42-.59H20.5c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H32.5c1.1 0 2-.9 2-2V23.33c0-.53-.21-1.04-.59-1.41l-4.82-4.83zM27.5 22.5V18l5.5 5.5h-4.5c-.55 0-1-.45-1-1z"
        ></path>
      </g>
    </svg>
  ),
  attachImage: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="image-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="image-SVGID_2_">
        <use xlinkHref="#image-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#image-SVGID_2_)">
        <path
          fill="#AC44CF"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#BF59CF"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
        <path fill="#AC44CF" d="M17 24.5h18v9H17z"></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-image"
          d="M18.318 18.25h16.364c.863 0 1.727.827 1.811 1.696l.007.137v12.834c0 .871-.82 1.741-1.682 1.826l-.136.007H18.318a1.83 1.83 0 0 1-1.812-1.684l-.006-.149V20.083c0-.87.82-1.741 1.682-1.826l.136-.007h16.364zm5.081 8.22l-3.781 5.044c-.269.355-.052.736.39.736h12.955c.442-.011.701-.402.421-.758l-2.682-3.449a.54.54 0 0 0-.841-.011l-2.262 2.727-3.339-4.3a.54.54 0 0 0-.861.011zm8.351-5.22a1.75 1.75 0 1 0 .001 3.501 1.75 1.75 0 0 0-.001-3.501z"
        ></path>
      </g>
    </svg>
  ),
  attachRooms: (props) => (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 53 53"
      width="53"
      height="53"
      {...props}
    >
      <defs>
        <circle id="rooms-SVGID_1_" cx="26.5" cy="26.5" r="25.5"></circle>
      </defs>
      <clipPath id="rooms-SVGID_2_">
        <use xlinkHref="#rooms-SVGID_1_" overflow="visible"></use>
      </clipPath>
      <g clipPath="url(#rooms-SVGID_2_)">
        <path
          fill="#396CD3"
          d="M26.5-1.1C11.9-1.1-1.1 5.6-1.1 27.6h55.2c-.1-19-13-28.7-27.6-28.7z"
        ></path>
        <path
          fill="#4079EC"
          d="M53 26.5H-1.1c0 14.6 13 27.6 27.6 27.6s27.6-13 27.6-27.6H53z"
        ></path>
        <path fill="#396CD3" d="M17 24.5h15v9H17z"></path>
      </g>
      <g fill="#F5F5F5">
        <path
          id="svg-rooms"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.5 18a3.5 3.5 0 0 1 3.5 3.5v10a3.5 3.5 0 0 1-3.5 3.5h-10a3.5 3.5 0 0 1-3.5-3.5v-10a3.5 3.5 0 0 1 3.5-3.5h10zm-7.925 6.782a.804.804 0 0 0-1.045-.073l-.708.698-.297.33-.134.177a4.075 4.075 0 0 0 .433 5.265 4.07 4.07 0 0 0 2.886 1.198c.976 0 1.952-.349 2.73-1.05l.784-.777.077-.091.063-.102.045-.105a.797.797 0 0 0-.189-.824.806.806 0 0 0-1.045-.073l-.704.694-.123.116-.147.119-.15.105a2.5 2.5 0 0 1-3.099-.337 2.492 2.492 0 0 1-.12-3.392l.748-.756.076-.091.063-.102.046-.105a.794.794 0 0 0-.19-.824zm5.281-.637a.803.803 0 0 0-1.044-.073l-3.67 3.662-.078.091-.063.102-.045.105a.793.793 0 0 0 .754 1.056.805.805 0 0 0 .481-.16l3.671-3.662.076-.09.064-.102.045-.105a.795.795 0 0 0-.191-.824zm2.323-2.323a4.078 4.078 0 0 0-5.615-.149l-.785.777-.073.084-.062.098a.806.806 0 0 0 .14.941.803.803 0 0 0 1.043.072l.705-.693.127-.119.137-.111a2.494 2.494 0 0 1 3.257.227c.921.923.972 2.413.117 3.392l-.746.755-.072.084-.062.098a.8.8 0 0 0 .139.941.8.8 0 0 0 1.043.072l.709-.697.148-.156.145-.17a4.084 4.084 0 0 0-.295-5.446zm9.815-.188l.006.129v9.474c0 1.31-1.714 1.998-2.744 1.12l-.878-.847a2.828 2.828 0 0 1-.871-1.849l-.007-.19v-5.943c0-.765.316-1.498.879-2.039l.877-.846c.996-.848 2.631-.234 2.738.991z"
        ></path>
      </g>
    </svg>
  ),
  back: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8 8-8z"
      ></path>
    </svg>
  ),
  block: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 2.8c-5.3 0-9.7 4.3-9.7 9.7s4.3 9.7 9.7 9.7 9.7-4.3 9.7-9.7-4.4-9.7-9.7-9.7zm-7.3 9.7c0-4 3.3-7.3 7.3-7.3 1.6 0 3.1.5 4.3 1.4L6.1 16.8c-.9-1.2-1.4-2.7-1.4-4.3zm7.3 7.3c-1.6 0-3-.5-4.2-1.4L17.9 8.3c.9 1.2 1.4 2.6 1.4 4.2 0 4-3.3 7.3-7.3 7.3z"
      ></path>
    </svg>
  ),
  cancel: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.1 17.2l-5.3-5.3 5.3-5.3-1.8-1.8-5.3 5.4-5.3-5.3-1.8 1.7 5.3 5.3-5.3 5.3L6.7 19l5.3-5.3 5.3 5.3 1.8-1.8z"
      ></path>
    </svg>
  ),
  chat: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.005 3.175H4.674C3.642 3.175 3 3.789 3 4.821V21.02l3.544-3.514h12.461c1.033 0 2.064-1.06 2.064-2.093V4.821c-.001-1.032-1.032-1.646-2.064-1.646zm-4.989 9.869H7.041V11.1h6.975v1.944zm3-4H7.041V7.1h9.975v1.944z"
      ></path>
    </svg>
  ),
  check: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="check"
      viewBox="0 0 18 13"
      fill="none"
      {...props}
    >
      <path
        d="M6.99974 10.172L16.1917 0.979004L17.6067 2.393L6.99974 13L0.635742 6.636L2.04974 5.222L6.99974 10.172Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  delete: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
    >
      <g clip-path="url(#clip0_99_400)">
        <path
          d="M3.25929 0.414609C3.38946 0.1605 3.65705 0 3.94875 0H6.85125C7.14295 0 7.41054 0.1605 7.54071 0.414609L7.71429 0.75H10.0286C10.4553 0.75 10.8 1.08586 10.8 1.5C10.8 1.91414 10.4553 2.25 10.0286 2.25H0.771429C0.345455 2.25 0 1.91414 0 1.5C0 1.08586 0.345455 0.75 0.771429 0.75H3.08571L3.25929 0.414609ZM0.749732 3H10.0286V10.5C10.0286 11.3273 9.3367 12 8.48571 12H2.29259C1.4621 12 0.749732 11.3273 0.749732 10.5V3ZM2.6783 4.875V10.125C2.6783 10.3313 2.87357 10.5 3.06402 10.5C3.29786 10.5 3.44973 10.3313 3.44973 10.125V4.875C3.44973 4.66875 3.29786 4.5 3.06402 4.5C2.87357 4.5 2.6783 4.66875 2.6783 4.875ZM4.99259 4.875V10.125C4.99259 10.3313 5.18786 10.5 5.3783 10.5C5.61214 10.5 5.78571 10.3313 5.78571 10.125V4.875C5.78571 4.66875 5.61214 4.5 5.3783 4.5C5.18786 4.5 4.99259 4.66875 4.99259 4.875ZM7.32857 4.875V10.125C7.32857 10.3313 7.50214 10.5 7.71429 10.5C7.92643 10.5 8.1 10.3313 8.1 10.125V4.875C8.1 4.66875 7.92643 4.5 7.71429 4.5C7.50214 4.5 7.32857 4.66875 7.32857 4.875Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_99_400">
          <rect width="10.8" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  doubleTick: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 15"
      width="16"
      height="15"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
      ></path>
    </svg>
  ),
  downArrow: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 20"
      width="19"
      height="20"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.8 6.7l5.7 5.7 5.7-5.7 1.6 1.6-7.3 7.2-7.3-7.2 1.6-1.6z"
      ></path>
    </svg>
  ),
  upArrow: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 20"
      width="19"
      height="20"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.8 13.3l5.7-5.7 5.7 5.7 1.6-1.6-7.3-7.2-7.3 7.2 1.6 1.6z"
      ></path>
    </svg>
  ),
  emojiActivity: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.8 15.3l1.3-3.8c.1-.2 0-.5-.2-.6l-3.3-2.4c-.2-.1-.5-.1-.6 0l-3.3 2.4c-.2.1-.3.4-.2.6l1.3 3.8c.1.2.3.4.5.4h4c.2 0 .4-.2.5-.4z"
      ></path>
      <path
        fill="currentColor"
        d="M12 1.9C6.4 1.9 1.9 6.4 1.9 12S6.4 22.1 12 22.1 22.1 17.6 22.1 12 17.6 1.9 12 1.9zM9.8 20.3c.1-.2.1-.4 0-.6l-1.4-2.3c-.1-.1-.2-.2-.4-.3l-2.5-.6c-.2-.1-.5.1-.6.2-.9-1.3-1.4-2.9-1.5-4.5.2 0 .4 0 .5-.2l1.7-2c.1 0 .2-.2.2-.3l-.3-2.6c0-.2-.1-.3-.3-.4C6.2 5.4 7.5 4.5 9 4c0 .1.2.3.3.3l2.5 1.1c.1.1.3.1.4 0l2.5-1.1.3-.3c1.5.6 2.7 1.5 3.7 2.7-.1.1-.2.2-.2.4l-.2 2.6c0 .2 0 .3.1.4l1.7 2c.1.1.3.2.4.2 0 1.6-.5 3.1-1.3 4.4-.1-.1-.2-.1-.4-.1l-2.5.6c-.1 0-.3.1-.4.3l-1.4 2.3c-.1.2-.1.3 0 .5-.8.2-1.6.4-2.5.4-.7-.1-1.5-.2-2.2-.4z"
      ></path>
    </svg>
  ),
  emojiFlags: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M5.5 3.8v-.2c0-.3-.2-.5-.5-.5h-.5c-.3 0-.5.2-.5.5V21c0 .3.2.5.5.5H5c.3 0 .5-.2.5-.5v-6.2c5 1.8 9.3-2.7 14.5.6V4.1C14.9 1 10.3 5.6 5.5 3.8zm10.3 8.8c-1.4 0-2.8.3-4.1.6-1.2.3-2.4.5-3.5.5-.9 0-1.8-.2-2.6-.5V5.4c.8.2 1.5.3 2.3.3 1.5 0 2.9-.4 4.3-.7 1.3-.3 2.5-.6 3.8-.6.9 0 1.7.2 2.5.5V13c-.9-.2-1.8-.4-2.7-.4z"
      ></path>
    </svg>
  ),
  emojiFood: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.4 11.4c-.4 0-.8.4-.8.8V14c0 .4.4.8.8.8s.8-.4.6-.8v-1.8c0-.6-.2-.8-.6-.8zM4.6 10.4c-.4 0-.8.4-.8.8V15c0 .4.4.8.8.8s.8-.4.8-.8v-3.8c0-.6-.4-.8-.8-.8z"
      ></path>
      <path
        fill="currentColor"
        d="M23 7.2c-.6-.6-1.6-.8-2.8-.6-.2 0-.4.2-.6.2V4.2c0-.6-.6-1.2-1.2-1.2h-17C.8 3 .2 3.6.2 4.2v7.4c0 5.4 3.2 9.6 8.4 9.6h2.2c4.2 0 7-2.6 8-6h.4c2.2-.4 4-2.6 4.4-4.8.4-1.4.2-2.4-.6-3.2zm-4.8-2.8v3H1.6v-3h16.6zM11 19.8H8.8c-5.2 0-7-4.4-7-8.2V8.8h16.6v2.8c-.2 4-2.4 8.2-7.4 8.2zm8.4-6.2c.2-.6.2-1.4.2-2V8.4c.4-.2.6-.4 1-.4.6-.2 1.2 0 1.4.4.4.4.6 1 .4 1.8-.2 1.4-1.6 3-3 3.4z"
      ></path>
    </svg>
  ),
  emojiNature: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.2 12.2c.608 0 1.1.627 1.1 1.4S7.808 15 7.2 15s-1.1-.627-1.1-1.4.492-1.4 1.1-1.4zm9.7 0c.608 0 1.1.627 1.1 1.4s-.492 1.4-1.1 1.4-1.1-.627-1.1-1.4.492-1.4 1.1-1.4zm4.6-1.1l-1.2-2.4c.9-.4 1.7-1.3 2-2.2.3-.7.4-2.1-1-3.5-1-.9-2-1.2-2.9-1-1.1.3-1.9 1.2-2.3 1.9-1.4-.7-2.9-.8-4.1-.8-1.5 0-2.8.3-4 .9-.5-.9-1.2-1.8-2.3-2.1-1-.2-2 .1-2.9 1-1 1-1.4 2.2-1 3.4.4 1.1 1.2 1.9 2 2.3-.2.5-.4 1-.6 1.6l-.2.2c-.3.7-.5 1.3-.8 1.9-.4 1-.9 1.9-.9 3.1 0 1.6.8 6.7 10.5 6.7 3.8 0 6.6-.7 8.5-2.2s2.2-3.4 2.2-4.3c.2-2.1-.2-2.9-1-4.5zm-2.7-7.6c.4-.1.9.1 1.5.6.6.6.8 1.2.6 1.8-.2.6-.7 1.1-1.2 1.3-.6-1.2-1.3-2-2.1-2.6.2-.4.6-1 1.2-1.1zM3.3 5.9c-.2-.6 0-1.2.6-1.8.5-.5 1.1-.7 1.5-.6.5.1 1.1.7 1.3 1.2-.9.7-1.6 1.5-2.2 2.6C4 7 3.4 6.5 3.3 5.9zm17.8 9.7c0 .7-.2 2-1.6 3.1-1.5 1.2-4.1 1.8-7.5 1.8-8.3 0-8.9-3.9-8.9-5.1 0-.8.3-1.5.7-2.4.3-.6.6-1.2.8-2.1l.1-.2c.5-1.5 2-6.2 7.3-6.2 1.2 0 2.5.2 3.7.9.1.1.5.3.5.3.9.7 1.7 1.7 2.4 3.2.6 1.3 1 2.2 1.4 2.9.8 1.6 1.1 2.1 1.1 3.8zM14.6 17c-.1.1-.6.4-1.2.3-.4-.1-.7-.3-.9-.8 0-.1-.1-.1-.1-.2.8-.1 1.3-.6 1.3-1.3s-.7 0-1.7 0c-.9 0-1.7-.7-1.7 0 0 .6.6 1.2 1.4 1.3l-.1.1c-.3.4-.5.7-.9.8-.5.1-1.1-.1-1.3-.3-.2-.2-.5-.1-.7.1s-.1.5.1.7c.1.1.8.5 1.6.5.2 0 .4 0 .5-.1.4-.1.8-.3 1.1-.7.4.4.9.6 1.2.7.8.2 1.7-.2 2-.5.2-.2.2-.5 0-.7-.1 0-.4-.1-.6.1z"
      ></path>
    </svg>
  ),
  emojiObjects: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M18.8 6.7c-.9-2.6-3.2-4.6-6-4.9h-1.6c-2.8.3-5.1 2.2-6 4.9-1 3 .1 6.2 2.7 8H8c.2.1.3.4.3.6v2c0 .8.6 1.4 1.4 1.4h4.6c.8 0 1.4-.6 1.4-1.4v-2c0-.2.1-.5.3-.6l.1-.1c2.5-1.8 3.6-5 2.7-7.9zm-3.5 6.9l-.1.1c-.5.4-.9 1-.9 1.7v2s0 .1-.1.1H9.8s-.1 0-.1-.1v-2c0-.7-.3-1.3-.9-1.7l-.1-.1c-2-1.4-3-4-2.2-6.5.7-2.1 2.6-3.7 4.9-3.9H12.7c2.2.2 4.2 1.8 4.9 3.9.7 2.4-.2 5-2.3 6.5zM9.2 21.2c0 .6.5 1 1 1h3.7c.6 0 1-.5 1-1v-1H9.2v1z"
      ></path>
      <path
        fill="currentColor"
        d="M13.6 10.5c-.4 0-.8.3-.8.8 0 .1 0 .2.1.3-.2.3-.5.5-.8.5s-.6-.2-.8-.5c0-.1.1-.2.1-.3 0-.4-.3-.8-.8-.8-.4 0-.8.3-.8.8 0 .4.3.7.7.8.3.4.7.7 1.1.8V15c0 .2.2.4.4.4s.4-.2.4-.4v-2.1c.4-.1.8-.4 1.1-.8.4 0 .8-.3.8-.8s-.3-.8-.7-.8z"
      ></path>
    </svg>
  ),
  emojiPeople: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 22.1C6.4 22.1 1.9 17.6 1.9 12S6.4 1.9 12 1.9 22.1 6.4 22.1 12 17.6 22.1 12 22.1zm0-18.6c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5z"
      ></path>
      <path
        fill="currentColor"
        d="M8.9 11.6c.7 0 1.3-.7 1.3-1.5s-.6-1.5-1.3-1.5-1.3.7-1.3 1.5.6 1.5 1.3 1.5zM17.1 13.6c-1.1.1-3 .4-5 .4s-4-.3-5-.4c-.4 0-.6.3-.4.7 1.1 2 3.1 3.5 5.5 3.5 2.3 0 4.4-1.5 5.5-3.5.1-.3-.2-.7-.6-.7zM12.3 16c-2.6 0-4.1-1-4.2-1.6 0 0 4.4.9 8 0 0 0-.5 1.6-3.8 1.6zM15.1 11.6c.7 0 1.3-.7 1.3-1.5s-.6-1.5-1.3-1.5-1.3.7-1.3 1.5.6 1.5 1.3 1.5z"
      ></path>
    </svg>
  ),
  emojiSymbols: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.5 12.9V11h2.2l-.2-1.3h-2V7.3H13v2.5h-2V7.4H9.5v2.4H7.2l.2 1.2h2.1v1.9H7.3l.2 1.3h2v2.4H11v-2.4h2v2.4h1.5v-2.4h2.3l-.2-1.3h-2.1zM11 11h2v1.9h-2V11z"
      ></path>
      <path
        fill="currentColor"
        d="M16.1 2.6H7.9C5 2.6 2.6 5 2.6 7.9V16c0 3 2.4 5.3 5.3 5.3H16c3 0 5.3-2.4 5.3-5.3V7.9c.1-2.9-2.3-5.3-5.2-5.3zm3.7 13.5c0 2.1-1.6 3.8-3.7 3.8H7.9c-2.1 0-3.8-1.7-3.8-3.8V7.9c0-2.1 1.7-3.8 3.8-3.8H16c2.1 0 3.8 1.7 3.8 3.8v8.2z"
      ></path>
    </svg>
  ),
  emojiTravel: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.5 11.5c0-.7-.1-1.4-.3-2l-1.5-4.3C19.2 3.9 18 3 16.6 3H7.3c-1.4 0-2.6.9-3.1 2.2L2.6 9.9c-.1.4-.2.7-.2 1.1v8.6c0 .6.5 1.1 1.1 1.1h1.1c.6 0 1.1-.5 1.1-1.1v-1.1h12.7v1.1c0 .6.5 1.1 1.1 1.1h1.1c.6 0 1.1-.5 1.1-1.1v-7.4l-.2-.7zM4.1 10.4l1.6-4.7c.2-.7.9-1.2 1.7-1.2h9.2c.7 0 1.4.5 1.6 1.2l1.5 4.3c.1.3.2.6.2.8H4c-.1-.1 0-.3.1-.4zm1.4 5.7c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5c-.1.8-.7 1.5-1.5 1.5zm9.4-.6H9.3c-.5 0-1-.4-1-1 0-.5.4-1 1-1h5.6c.5 0 1 .4 1 1-.1.6-.5 1-1 1zm3.7.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5z"
      ></path>
    </svg>
  ),
  gif: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M13.177 12.013l-.001-.125v-.541-.512c0-.464 0-.827-.002-1.178a.723.723 0 0 0-.557-.7.715.715 0 0 0-.826.4c-.05.115-.072.253-.073.403-.003 1.065-.003 1.917-.002 3.834v.653c0 .074.003.136.009.195a.72.72 0 0 0 .57.619c.477.091.878-.242.881-.734.002-.454.003-.817.002-1.633l-.001-.681zm-3.21-.536a35.751 35.751 0 0 0-1.651-.003c-.263.005-.498.215-.565.48a.622.622 0 0 0 .276.7.833.833 0 0 0 .372.104c.179.007.32.008.649.005l.137-.001v.102c-.001.28-.001.396.003.546.001.044-.006.055-.047.081-.242.15-.518.235-.857.275-.767.091-1.466-.311-1.745-1.006a2.083 2.083 0 0 1-.117-1.08 1.64 1.64 0 0 1 1.847-1.41c.319.044.616.169.917.376.196.135.401.184.615.131a.692.692 0 0 0 .541-.562c.063-.315-.057-.579-.331-.766-.789-.542-1.701-.694-2.684-.482-2.009.433-2.978 2.537-2.173 4.378.483 1.105 1.389 1.685 2.658 1.771.803.054 1.561-.143 2.279-.579.318-.193.498-.461.508-.803.014-.52.015-1.046.001-1.578-.009-.362-.29-.669-.633-.679zM18 4.25H6A4.75 4.75 0 0 0 1.25 9v6A4.75 4.75 0 0 0 6 19.75h12A4.75 4.75 0 0 0 22.75 15V9A4.75 4.75 0 0 0 18 4.25zM21.25 15A3.25 3.25 0 0 1 18 18.25H6A3.25 3.25 0 0 1 2.75 15V9A3.25 3.25 0 0 1 6 5.75h12A3.25 3.25 0 0 1 21.25 9v6zm-2.869-6.018H15.3c-.544 0-.837.294-.837.839V14.309c0 .293.124.525.368.669.496.292 1.076-.059 1.086-.651.005-.285.006-.532.004-1.013v-.045l-.001-.46v-.052h1.096l1.053-.001a.667.667 0 0 0 .655-.478c.09-.298-.012-.607-.271-.757a.985.985 0 0 0-.468-.122 82.064 82.064 0 0 0-1.436-.006h-.05l-.523.001h-.047v-1.051h1.267l1.22-.001c.458-.001.768-.353.702-.799-.053-.338-.35-.56-.737-.561z"
      ></path>
    </svg>
  ),
  laptop: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 18"
      width="21"
      height="18"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.426 14.235a.767.767 0 0 1-.765-.765c0-.421.344-.765.765-.765s.765.344.765.765-.344.765-.765.765zM4.309 3.529h12.235v8.412H4.309V3.529zm12.235 9.942c.841 0 1.522-.688 1.522-1.529l.008-8.412c0-.842-.689-1.53-1.53-1.53H4.309c-.841 0-1.53.688-1.53 1.529v8.412c0 .841.688 1.529 1.529 1.529H1.25c0 .842.688 1.53 1.529 1.53h15.294c.841 0 1.529-.688 1.529-1.529h-3.058z"
      ></path>
    </svg>
  ),
  lock: (props) => (
    <svg
      width="10px"
      height="12px"
      viewBox="0 0 10 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.00847986,1.6 C6.38255462,1.6 7.50937014,2.67435859 7.5940156,4.02703389 L7.59911976,4.1906399 L7.599,5.462 L7.75719976,5.46214385 C8.34167974,5.46214385 8.81591972,5.94158383 8.81591972,6.53126381 L8.81591972,9.8834238 C8.81591972,10.4731038 8.34167974,10.9525438 7.75719976,10.9525438 L2.25767996,10.9525438 C1.67527998,10.9525438 1.2,10.4731038 1.2,9.8834238 L1.2,6.53126381 C1.2,5.94158383 1.67423998,5.46214385 2.25767996,5.46214385 L2.416,5.462 L2.41679995,4.1906399 C2.41679995,2.81636129 3.49135449,1.68973395 4.84478101,1.60510326 L5.00847986,1.6 Z M5.00847986,2.84799995 C4.31163824,2.84799995 3.73624912,3.38200845 3.6709675,4.06160439 L3.6647999,4.1906399 L3.663,5.462 L6.35,5.462 L6.35111981,4.1906399 C6.35111981,3.53817142 5.88169076,2.99180999 5.26310845,2.87228506 L5.13749818,2.85416626 L5.00847986,2.84799995 Z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  menu: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 7a2 2 0 1 0-.001-4.001A2 2 0 0 0 12 7zm0 2a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 9zm0 6a2 2 0 1 0-.001 3.999A2 2 0 0 0 12 15z"
      ></path>
    </svg>
  ),
  microphone: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M11.999 14.942c2.001 0 3.531-1.53 3.531-3.531V4.35c0-2.001-1.53-3.531-3.531-3.531S8.469 2.35 8.469 4.35v7.061c0 2.001 1.53 3.531 3.53 3.531zm6.238-3.53c0 3.531-2.942 6.002-6.237 6.002s-6.237-2.471-6.237-6.002H3.761c0 4.001 3.178 7.297 7.061 7.885v3.884h2.354v-3.884c3.884-.588 7.061-3.884 7.061-7.885h-2z"
      ></path>
    </svg>
  ),
  notification: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48"
      height="48"
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.154 2C11.919 2 2 11.924 2 24.165S11.919 46.33 24.154 46.33s22.154-9.924 22.154-22.165S36.389 2 24.154 2zm-.744 15.428v-.618c0-.706.618-1.324 1.324-1.324s1.323.618 1.323 1.324v.618c2.559.618 4.412 2.823 4.412 5.559v3.176l-8.294-8.294a5.056 5.056 0 0 1 1.235-.441zm1.323 15.706a1.77 1.77 0 0 1-1.765-1.765h3.529a1.768 1.768 0 0 1-1.764 1.765zm7.236-.883l-1.765-1.765H17.233v-.882l1.765-1.765v-4.853a5.56 5.56 0 0 1 .794-2.912l-2.559-2.559 1.147-1.147 14.735 14.736-1.146 1.147z"
      ></path>
    </svg>
  ),
  noWifi: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      width="48"
      height="48"
      {...props}
    >
      <path
        fill="currentColor"
        d="M24.154 2C11.919 2 2 11.924 2 24.165S11.919 46.33 24.154 46.33s22.154-9.924 22.154-22.165S36.389 2 24.154 2zm-.169 32.138L12.976 19.459c3.028-2.294 6.881-3.67 11.009-3.67 4.129 0 7.982 1.376 11.009 3.67L23.985 34.138zm-.945-5.65h1.981v-1.981H23.04v1.981zm0-3.962h1.981v-5.017H23.04v5.017z"
      ></path>
    </svg>
  ),
  pinned: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 19"
      width="19"
      height="19"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.5 18.419C4.574 18.419.581 14.426.581 9.5S4.574.581 9.5.581s8.919 3.993 8.919 8.919-3.993 8.919-8.919 8.919zm2.121-5.708l-.082-2.99 1.647-1.963a1.583 1.583 0 0 0-.188-2.232l-.32-.269a1.58 1.58 0 0 0-2.231.203L8.803 7.42l-2.964.439a.282.282 0 0 0-.14.496l5.458 4.58c.186.157.47.019.464-.224zM5.62 13.994a.504.504 0 0 0 .688-.038l2.204-2.307-1.085-.91-1.889 2.571a.504.504 0 0 0 .082.684z"
      ></path>
    </svg>
  ),
  recent: (props) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.538 11.975a8.563 8.563 0 1 0-17.126 0 8.563 8.563 0 0 0 17.126 0zm1.412 0c0 5.509-4.466 9.975-9.975 9.975C6.465 21.95 2 17.484 2 11.975 2 6.465 6.466 2 11.975 2c5.509 0 9.975 4.466 9.975 9.975zm-9.832-5.27v5.692l4.386 2.627a.706.706 0 1 1-.725 1.212l-5.073-3.04v-6.49a.706.706 0 1 1 1.412 0z"
        fill="currentColor"
      ></path>
    </svg>
  ),
  rightArrow: (props) => (
    <span
      data-testid="chevron-right-alt"
      data-icon="chevron-right-alt"
      className="pQbiR"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 21"
        width="10"
        height="21"
      >
        <path
          fill="currentColor"
          d="M1 15.75l5.2-5.2L1 5.35l1.5-1.5 6.5 6.7-6.6 6.6-1.4-1.4z"
        ></path>
      </svg>
    </span>
  ),
  search: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M15.009 13.805h-.636l-.22-.219a5.184 5.184 0 0 0 1.256-3.386 5.207 5.207 0 1 0-5.207 5.208 5.183 5.183 0 0 0 3.385-1.255l.221.22v.635l4.004 3.999 1.194-1.195-3.997-4.007zm-4.808 0a3.605 3.605 0 1 1 0-7.21 3.605 3.605 0 0 1 0 7.21z"
      ></path>
    </svg>
  ),
  send: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"
      ></path>
    </svg>
  ),
  singleTick: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 15"
      width="16"
      height="15"
      {...props}
    >
      <path
        fill="currentColor"
        d="M10.91 3.316l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
      ></path>
    </svg>
  ),
  smiley: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M9.153 11.603c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962zm-3.204 1.362c-.026-.307-.131 5.218 6.063 5.551 6.066-.25 6.066-5.551 6.066-5.551-6.078 1.416-12.129 0-12.129 0zm11.363 1.108s-.669 1.959-5.051 1.959c-3.505 0-5.388-1.164-5.607-1.959 0 0 5.912 1.055 10.658 0zM11.804 1.011C5.609 1.011.978 6.033.978 12.228s4.826 10.761 11.021 10.761S23.02 18.423 23.02 12.228c.001-6.195-5.021-11.217-11.216-11.217zM12 21.354c-5.273 0-9.381-3.886-9.381-9.159s3.942-9.548 9.215-9.548 9.548 4.275 9.548 9.548c-.001 5.272-4.109 9.159-9.382 9.159zm3.108-9.751c.795 0 1.439-.879 1.439-1.962s-.644-1.962-1.439-1.962-1.439.879-1.439 1.962.644 1.962 1.439 1.962z"
      ></path>
    </svg>
  ),
  status: (props) => (
    <svg
      id="df9d3429-f0ef-48b5-b5eb-f9d27b2deba6"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.072 1.761a10.05 10.05 0 0 0-9.303 5.65.977.977 0 0 0 1.756.855 8.098 8.098 0 0 1 7.496-4.553.977.977 0 1 0 .051-1.952zM1.926 13.64a10.052 10.052 0 0 0 7.461 7.925.977.977 0 0 0 .471-1.895 8.097 8.097 0 0 1-6.012-6.386.977.977 0 0 0-1.92.356zm13.729 7.454a10.053 10.053 0 0 0 6.201-8.946.976.976 0 1 0-1.951-.081v.014a8.097 8.097 0 0 1-4.997 7.209.977.977 0 0 0 .727 1.813l.02-.009z"
      ></path>
      <path fill="#009588" d="M19 1.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"></path>
    </svg>
  ),
  sticker: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M21.799 10.183c-.002-.184-.003-.373-.008-.548-.02-.768-.065-1.348-.173-1.939a6.6 6.6 0 0 0-.624-1.87 6.24 6.24 0 0 0-1.171-1.594 6.301 6.301 0 0 0-1.614-1.159 6.722 6.722 0 0 0-1.887-.615c-.59-.106-1.174-.15-1.961-.171-.318-.008-3.607-.012-4.631 0-.798.02-1.383.064-1.975.17a6.783 6.783 0 0 0-1.888.616 6.326 6.326 0 0 0-2.785 2.753 6.658 6.658 0 0 0-.623 1.868c-.107.591-.152 1.186-.173 1.941-.008.277-.016 2.882-.016 2.882 0 .52.008 1.647.016 1.925.02.755.066 1.349.172 1.938.126.687.33 1.3.624 1.871.303.59.698 1.126 1.173 1.595a6.318 6.318 0 0 0 1.614 1.159 6.786 6.786 0 0 0 2.146.656c.479.068.833.087 1.633.108.035.001 2.118-.024 2.578-.035a6.873 6.873 0 0 0 4.487-1.811 210.877 210.877 0 0 0 2.928-2.737 6.857 6.857 0 0 0 2.097-4.528l.066-1.052.001-.668c.001-.023-.005-.738-.006-.755zm-3.195 5.92c-.79.757-1.784 1.684-2.906 2.716a5.356 5.356 0 0 1-2.044 1.154c.051-.143.116-.276.145-.433.042-.234.06-.461.067-.74.003-.105.009-.789.009-.789.013-.483.042-.865.107-1.22.069-.379.179-.709.336-1.016.16-.311.369-.595.621-.844.254-.252.542-.458.859-.617.314-.158.65-.268 1.037-.337a8.127 8.127 0 0 1 1.253-.106s.383.001.701-.003a4.91 4.91 0 0 0 .755-.066c.186-.034.348-.105.515-.169a5.35 5.35 0 0 1-1.455 2.47zm1.663-4.757a1.128 1.128 0 0 1-.615.859 1.304 1.304 0 0 1-.371.119 3.502 3.502 0 0 1-.52.043c-.309.004-.687.004-.687.004-.613.016-1.053.049-1.502.129a5.21 5.21 0 0 0-1.447.473 4.86 4.86 0 0 0-2.141 2.115 5.088 5.088 0 0 0-.479 1.434 9.376 9.376 0 0 0-.131 1.461s-.006.684-.008.777c-.006.208-.018.37-.043.511a1.154 1.154 0 0 1-.626.86c-.072.036-.168.063-.37.098-.027.005-.25.027-.448.031-.021 0-1.157.01-1.192.009-.742-.019-1.263-.046-1.668-.126a5.27 5.27 0 0 1-1.477-.479 4.823 4.823 0 0 1-2.127-2.1 5.141 5.141 0 0 1-.482-1.453c-.09-.495-.13-1.025-.149-1.71a36.545 36.545 0 0 1-.012-.847c-.003-.292.005-3.614.012-3.879.02-.685.061-1.214.151-1.712a5.12 5.12 0 0 1 .481-1.45c.231-.449.53-.856.892-1.213.363-.36.777-.657 1.233-.886a5.26 5.26 0 0 1 1.477-.479c.503-.09 1.022-.129 1.74-.149a342.03 342.03 0 0 1 4.561 0c.717.019 1.236.058 1.737.148a5.263 5.263 0 0 1 1.476.478 4.835 4.835 0 0 1 2.126 2.098c.228.441.385.913.482 1.453.091.499.131 1.013.15 1.712.008.271.014 1.098.014 1.235a2.935 2.935 0 0 1-.037.436z"
      ></path>
    </svg>
  ),
  thumbsDown: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.091 4.2H6.318c-.691 0-1.295.432-1.555 1.036l-2.591 6.132c-.086.173-.172.346-.172.605V13.7c0 .95.777 1.727 1.727 1.727h5.441L8.305 19.4v.259c0 .345.173.691.345.95l.95.864 5.7-5.7c.345-.345.518-.777.518-1.209V5.927c0-.95-.777-1.727-1.727-1.727zm3.454 0v10.364H21V4.2h-3.455z"
        id="thumb-down"
      ></path>
    </svg>
  ),
  whatsapp: (props) => (
    <svg
      fill="#000000"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="48px"
      height="48px"
      {...props}
    >
      <path d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z" />
    </svg>
  ),
  ellipsis: (props) => (
    <svg
      width="5"
      height="18"
      viewBox="0 0 5 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 4.5C1.008 4.5 0 3.492 0 2.25C0 1.008 1.008 0 2.25 0C3.492 0 4.5 1.008 4.5 2.25C4.5 3.492 3.492 4.5 2.25 4.5ZM2.25 11.25C1.008 11.25 0 10.242 0 9C0 7.758 1.008 6.75 2.25 6.75C3.492 6.75 4.5 7.758 4.5 9C4.5 10.242 3.492 11.25 2.25 11.25ZM2.25 18C1.008 18 0 16.992 0 15.75C0 14.508 1.008 13.5 2.25 13.5C3.492 13.5 4.5 14.508 4.5 15.75C4.5 16.992 3.492 18 2.25 18Z"
        fill="#757575"
      />
    </svg>
  ),
  brainai: (props) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_160_200)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3299 19.9992H2.8257C2.8257 19.9992 3.43736 16.7233 3.3532 15.2608C3.31903 14.6575 3.21903 14.0325 2.9032 13.5075C2.3657 12.6742 0.706529 10.4075 0.840696 7.31583C1.02736 2.975 4.75153 0 9.27903 0C13.5274 0 16.3682 2.50083 17.494 6.23583C17.7674 7.135 17.7532 7.52 17.3682 8.40833L17.3632 8.41917L18.8224 10.2042C19.039 10.5217 19.1665 10.8633 19.1665 11.2367C19.1665 11.6925 18.9724 12.1075 18.6582 12.4025C18.3515 12.69 18.019 12.7792 17.6182 12.9375C17.6182 12.9375 17.1382 15.0975 16.8907 15.68C16.3074 17.0492 15.249 17.0625 14.4157 17.2208C14.0874 17.29 14.0074 17.3317 13.8482 17.7883C13.6749 18.2808 13.5457 18.9842 13.3299 19.9992ZM9.29486 1.66583C5.72403 1.70583 2.84486 3.78917 2.52736 7.0725C2.36736 8.73167 2.9132 10.3942 3.7907 11.8267C4.29986 12.66 4.8782 13.1533 5.0107 15.0558C5.08653 16.15 4.96903 17.2525 4.80986 18.3325H11.9799C12.0974 17.795 12.2715 17.095 12.5524 16.6183C12.9265 15.98 13.4665 15.7025 14.1574 15.5733C14.8557 15.45 15.189 15.5242 15.3982 14.9192C15.5749 14.4367 15.9082 13.0683 16.0907 11.6675C17.0932 11.3883 16.6007 11.5333 17.4832 11.2017C17.3115 11.0067 15.8849 9.27333 15.779 9.035C15.499 8.4025 15.7407 8.04333 15.9665 7.44083C16.0382 7.23167 16.0165 7.14333 15.959 6.93C15.0849 3.63917 12.7165 1.66583 9.29486 1.66583ZM9.7282 4.16583C9.92986 4.73583 9.9882 5.10083 10.429 5.28333C10.8707 5.4675 11.174 5.24667 11.7157 4.98917L12.5099 5.7825C12.2499 6.32833 12.0324 6.62917 12.2149 7.06917C12.3974 7.50917 12.759 7.5675 13.3332 7.77083V8.89333C12.7657 9.09583 12.3974 9.15417 12.2149 9.59583C12.0315 10.0367 12.2507 10.3383 12.5099 10.8825L11.7157 11.6758C11.1682 11.415 10.8707 11.1975 10.4315 11.38C9.98903 11.565 9.92986 11.9308 9.7282 12.4992H8.60486C8.4032 11.9292 8.34486 11.5642 7.90403 11.3825L7.9032 11.3817C7.46236 11.1975 7.15986 11.4175 6.61653 11.6758L5.8232 10.8825C6.07736 10.3467 6.30153 10.04 6.11736 9.595C5.93403 9.15417 5.56653 9.09583 4.99986 8.89333V7.77083C5.56736 7.56917 5.93403 7.51083 6.11736 7.07C6.3007 6.6275 6.08236 6.3275 5.8232 5.7825L6.61653 4.98917C7.16403 5.24917 7.46236 5.46667 7.9032 5.28333C8.34403 5.10083 8.4032 4.7325 8.60486 4.16583H9.7282ZM9.16653 9.72167C8.39986 9.72167 7.77736 9.1 7.77736 8.3325C7.77736 7.565 8.39986 6.94333 9.16653 6.94333C9.9332 6.94333 10.5549 7.565 10.5549 8.3325C10.5549 9.1 9.9332 9.72167 9.16653 9.72167Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_160_200">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  vectorfile: (props) => (
    <svg
      width="14"
      height="24"
      viewBox="0 0 14 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5V17C12 19.757 9.757 22 7 22C4.243 22 2 19.757 2 17V5C2 3.346 3.346 2 5 2C6.654 2 8 3.346 8 5V14C8 14.551 7.551 15 7 15C6.449 15 6 14.551 6 14V6H4V14C4 15.657 5.343 17 7 17C8.657 17 10 15.657 10 14V5C10 2.239 7.761 0 5 0C2.239 0 0 2.239 0 5V17C0 20.866 3.134 24 7 24C10.866 24 14 20.866 14 17V5H12Z"
        fill="black"
      />
    </svg>
  ),
  threeDots: (props) => (
    <svg
      width="5"
      height="18"
      viewBox="0 0 5 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.25 4.5C1.008 4.5 0 3.492 0 2.25C0 1.008 1.008 0 2.25 0C3.492 0 4.5 1.008 4.5 2.25C4.5 3.492 3.492 4.5 2.25 4.5ZM2.25 11.25C1.008 11.25 0 10.242 0 9C0 7.758 1.008 6.75 2.25 6.75C3.492 6.75 4.5 7.758 4.5 9C4.5 10.242 3.492 11.25 2.25 11.25ZM2.25 18C1.008 18 0 16.992 0 15.75C0 14.508 1.008 13.5 2.25 13.5C3.492 13.5 4.5 14.508 4.5 15.75C4.5 16.992 3.492 18 2.25 18Z"
        fill="#757575"
      />
    </svg>
  ),
  share: (props) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7568 6.62666L9.60059 11.0534C9.15 11.4431 8.43779 11.128 8.43779 10.5214V7.97139C3.89355 8.03584 1.93535 9.16377 3.26367 13.4118C3.41106 13.8832 2.8415 14.2485 2.4416 13.9573C1.15986 13.0251 0 11.2438 0 9.44209C0 4.9831 3.73242 4.03974 8.4375 3.98408V1.64092C8.4375 1.03535 9.14883 0.719237 9.60029 1.10889L14.7565 5.53564C15.082 5.8415 15.082 6.34541 14.7568 6.62666Z"
        fill="#757575"
      />
    </svg>
  ),
  move: (props) => (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.35167 8.3325V11.0417C8.35167 11.385 8.63083 11.6667 8.97833 11.6667C9.135 11.6667 9.29083 11.6075 9.41 11.495C10.8892 10.0908 13.5308 7.585 14.74 6.4375C14.9067 6.28 15 6.06083 15 5.83333C15 5.605 14.9067 5.38667 14.74 5.22917C13.5308 4.08167 10.8892 1.575 9.41 0.1725C9.29083 0.0591665 9.135 0 8.97833 0C8.63083 0 8.35167 0.280833 8.35167 0.625V3.33417H0.835C0.3925 3.33417 0 3.72583 0 4.1675V7.49917C0 7.94083 0.3925 8.3325 0.835 8.3325H8.35167Z"
        fill="#757575"
      />
    </svg>
  ),
  selectFile: (props) => (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.49804 12H1.1956C1.1956 12 1.5626 10.0344 1.5121 9.15688C1.4916 8.79487 1.4316 8.41985 1.2421 8.10484C0.919603 7.60482 -0.0758863 6.24476 0.00461285 4.38968C0.116612 1.78507 2.35109 0 5.06756 0C7.61654 0 9.32102 1.50056 9.99651 3.74166C10.1605 4.28118 10.152 4.51219 9.92101 5.04521L9.91801 5.05171L10.7935 6.12276C10.9235 6.31326 11 6.51827 11 6.74228C11 7.01579 10.8835 7.2648 10.695 7.44181C10.511 7.61432 10.3115 7.66782 10.071 7.76282C10.071 7.76282 9.78301 9.05888 9.63451 9.40839C9.28452 10.2299 8.64952 10.2379 8.14953 10.3329C7.95253 10.3744 7.90453 10.3994 7.80903 10.6734C7.70503 10.969 7.62754 11.391 7.49804 12ZM5.07706 0.999542C2.93458 1.02354 1.2071 2.27359 1.0166 4.24368C0.920603 5.23922 1.2481 6.23676 1.77459 7.0963C2.08009 7.59632 2.42709 7.89233 2.50659 9.03388C2.55209 9.6904 2.48159 10.3519 2.38609 11H6.68805C6.75854 10.6774 6.86304 10.2574 7.03154 9.97141C7.25604 9.5884 7.58004 9.42189 7.99453 9.34439C8.41353 9.27039 8.61352 9.31489 8.73902 8.95187C8.84502 8.66236 9.04502 7.84133 9.15452 7.00079C9.75601 6.83328 9.46052 6.92029 9.99001 6.72128C9.88701 6.60428 9.03102 5.56423 8.96752 5.42123C8.79952 5.04171 8.94452 4.8262 9.08002 4.46469C9.12302 4.33918 9.11002 4.28618 9.07552 4.15817C8.55102 2.18359 7.13004 0.999542 5.07706 0.999542ZM5.33706 2.4996C5.45806 2.84162 5.49306 3.06063 5.75755 3.17013C6.02255 3.28064 6.20455 3.14813 6.52955 2.99362L7.00604 3.46964C6.85004 3.79716 6.71954 3.97767 6.82904 4.24168C6.93854 4.50569 7.15554 4.54069 7.50004 4.66269V5.33622C7.15954 5.45773 6.93854 5.49273 6.82904 5.75774C6.71904 6.02225 6.85054 6.20326 7.00604 6.52977L6.52955 7.00579C6.20105 6.84929 6.02255 6.71878 5.75905 6.82828C5.49356 6.93929 5.45806 7.1588 5.33706 7.49981H4.66307C4.54207 7.1578 4.50707 6.93879 4.24257 6.82978L4.24207 6.82928C3.97757 6.71878 3.79607 6.85079 3.47008 7.00579L2.99408 6.52977C3.14658 6.20826 3.28108 6.02425 3.17058 5.75724C3.06058 5.49273 2.84008 5.45773 2.50009 5.33622V4.66269C2.84058 4.54169 3.06058 4.50669 3.17058 4.24218C3.28058 3.97667 3.14958 3.79666 2.99408 3.46964L3.47008 2.99362C3.79857 3.14963 3.97757 3.28014 4.24207 3.17013C4.50657 3.06063 4.54207 2.83962 4.66307 2.4996H5.33706ZM5.00006 5.83324C4.54007 5.83324 4.16657 5.46023 4.16657 4.99971C4.16657 4.53919 4.54007 4.16617 5.00006 4.16617C5.46006 4.16617 5.83305 4.53919 5.83305 4.99971C5.83305 5.46023 5.46006 5.83324 5.00006 5.83324Z"
        fill="#757575"
      />
    </svg>
  ),
  upload: (props) => (
    <svg
      width="18"
      height="13"
      viewBox="0 0 18 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.66133 5.74047L6.99467 7.76568L6.50333 7.3182L8.99467 4.30484L11.4967 7.33538L10.9947 7.77493L9.328 5.74179V10.9145H8.66133V5.74047ZM13.3333 12.2365H4.66667C3.01267 12.2365 1.66667 10.9026 1.66667 9.26211C1.66667 7.82252 2.70333 6.59312 4.132 6.33798L4.65133 6.24545L4.68 5.72394C4.80333 3.44492 6.70067 1.66097 9 1.66097C11.2993 1.66097 13.1967 3.44492 13.3187 5.72394L13.348 6.24545L13.868 6.33798C15.296 6.59312 16.3333 7.82252 16.3333 9.26211C16.3333 10.9026 14.9873 12.2365 13.3333 12.2365ZM13.9853 5.68759C13.844 3.0761 11.6707 1 9 1C6.32933 1 4.15533 3.0761 4.014 5.68759C2.30067 5.99362 1 7.47617 1 9.26211C1 11.2695 2.642 12.8974 4.66667 12.8974H13.3333C15.358 12.8974 17 11.2695 17 9.26211C17 7.47617 15.6993 5.99362 13.9853 5.68759Z"
        fill="#757575"
        stroke="#757575"
        stroke-width="0.2"
      />
    </svg>
  ),
  table: (props) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.833333 0C0.435 0 0 0.315833 0 0.833333V14.1667C0 14.6833 0.4325 15 0.833333 15H14.1667C14.6842 15 15 14.5667 15 14.1667V0.833333C15 0.435 14.6842 0 14.1667 0H0.833333ZM6.875 13.75H1.25V8.125H6.875V13.75ZM13.75 8.125V13.75H8.125V8.125H13.75ZM13.75 1.25V6.875H8.125V1.25H13.75ZM1.25 1.25H6.875V6.875H1.25V1.25Z"
        fill="#757575"
      />
    </svg>
  ),
  uploadFile: (props) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1177_10233)">
        <path
          d="M5.83325 5.25H2.33325L6.99992 0L11.6666 5.25H8.16658V11.6667H5.83325V5.25ZM12.2499 11.6667V12.8333H1.74992V11.6667H0.583252V14H13.4166V11.6667H12.2499Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_1177_10233">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  pdf: (props) => (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.363 2C13.518 2 12 8 12 8C12 8 18 6.35 18 10.457V22H2V2H9.363ZM10.189 0H0V24H20V9.614C20 7.223 13.352 0 10.189 0ZM15 13H12.372V16.686H13.279V15.214H14.769V14.482H13.279V13.784H15V13ZM10.1 13H8.501V16.686H10.1C10.637 16.686 11.061 16.505 11.362 16.151C11.917 15.493 11.949 14.117 11.3 13.459C11.002 13.159 10.588 13 10.1 13ZM9.408 13.783H9.904C10.377 13.783 10.706 13.956 10.819 14.427C10.883 14.694 10.896 15.106 10.798 15.375C10.67 15.726 10.417 15.903 10.044 15.903H9.407V13.783H9.408ZM6.668 13H5V16.686H5.907V15.409H6.668C7.287 15.409 7.732 15.132 7.892 14.646C7.987 14.355 7.987 14.049 7.892 13.761C7.732 13.277 7.286 13 6.668 13ZM5.907 13.732H6.453C6.688 13.732 6.92 13.76 7.029 13.96C7.096 14.083 7.096 14.326 7.029 14.449C6.92 14.648 6.688 14.676 6.453 14.676H5.907V13.732Z"
        fill="black"
      />
    </svg>
  ),
  img: (props) => (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.363 2C13.518 2 12 8 12 8C12 8 18 6.35 18 10.457V22H2V2H9.363ZM10.189 0H0V24H20V9.614C20 7.223 13.352 0 10.189 0Z"
        fill="black"
      />
      <text x="4" y="18" font-family="Arial" font-size="5" fill="black">
        Media
      </text>
    </svg>
  ),
  file: (props) => (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.363 2C13.518 2 12 8 12 8C12 8 18 6.35 18 10.457V22H2V2H9.363ZM10.189 0H0V24H20V9.614C20 7.223 13.352 0 10.189 0Z"
        fill="black"
      />

      <text x="5" y="18" font-family="Arial" font-size="6" fill="black">
        File
      </text>
    </svg>
  ),
  chatDownArrow: () => (
    <svg
      width="8"
      height="17"
      viewBox="0 0 8 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.64645 16.3536C3.84171 16.5488 4.15829 16.5488 4.35355 16.3536L7.53553 13.1716C7.7308 12.9763 7.7308 12.6597 7.53553 12.4645C7.34027 12.2692 7.02369 12.2692 6.82843 12.4645L4 15.2929L1.17157 12.4645C0.976311 12.2692 0.659728 12.2692 0.464466 12.4645C0.269204 12.6597 0.269204 12.9763 0.464466 13.1716L3.64645 16.3536ZM3.5 0L3.5 16H4.5L4.5 0L3.5 0Z"
        fill="#1D1D1D"
      />
    </svg>
  ),
  plus: (props) => (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.3 1V13.6M1 7.3H13.6"
        stroke="#303030"
        stroke-width="1.35"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  aichatIconInput: (props) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33333 3.33267C8.93 3.82 10.18 5.07067 10.666 6.66667C11.1547 5.07 12.4047 3.82067 14 3.33333C12.4047 2.846 11.1547 1.59667 10.666 0C10.18 1.596 8.93 2.84533 7.33333 3.33267ZM12 7.99933C12.958 8.29133 13.708 9.042 13.9993 10C14.2927 9.042 15.0427 8.292 16 8C15.0427 7.70733 14.2927 6.958 13.9993 6C13.708 6.95733 12.958 7.70733 12 7.99933ZM8 11.6667C8.79867 11.91 9.42333 12.5353 9.666 13.3333C9.91 12.5347 10.5353 11.91 11.3333 11.6667C10.5353 11.4227 9.91067 10.7987 9.666 10C9.42333 10.798 8.79867 11.4227 8 11.6667ZM3.99933 3.33333C3.416 5.24867 1.914 6.75 0 7.334C1.91733 7.92067 3.416 9.41933 4.00267 11.3367C4.586 9.42067 6.088 7.92067 8 7.334C6.088 6.75133 4.586 5.24933 3.99933 3.33333Z"
        fill="#757575"
      />
    </svg>
  ),
  upArrow12: (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 20"
      width="11"
      height="12"
      {...props}
    >
      <path
        fill="currentColor"
        d="M3.8 13.3l5.7-5.7 5.7 5.7 1.6-1.6-7.3-7.2-7.3 7.2 1.6 1.6z"
      ></path>
    </svg>
  ),
  sendChatInput: (props) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00132 15.6979V1.30078M8.00132 1.30078L0.802734 8.49936M8.00132 1.30078L15.1999 8.49936"
        stroke="#FFF"
        stroke-width="1.2766"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  chatContinuous: (props) => (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="1" width="39" height="39" rx="4.5" fill="black" />
      <rect x="0.5" y="1" width="39" height="39" rx="4.5" stroke="#D9D9D9" />
      <rect
        width="15"
        height="15"
        transform="translate(12.5 13)"
        fill="white"
      />
    </svg>
  ),
  new_copy: () => (
    <svg
      width="21"
      height="21"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.95898 11.8747H3.16732C2.74739 11.8747 2.34466 11.7079 2.04773 11.4109C1.7508 11.114 1.58398 10.7113 1.58398 10.2913V3.16634C1.58398 2.74641 1.7508 2.34369 2.04773 2.04676C2.34466 1.74982 2.74739 1.58301 3.16732 1.58301H10.2923C10.7122 1.58301 11.115 1.74982 11.4119 2.04676C11.7088 2.34369 11.8757 2.74641 11.8757 3.16634V3.95801M8.70898 7.12467H15.834C16.7084 7.12467 17.4173 7.83356 17.4173 8.70801V15.833C17.4173 16.7075 16.7084 17.4163 15.834 17.4163H8.70898C7.83453 17.4163 7.12565 16.7075 7.12565 15.833V8.70801C7.12565 7.83356 7.83453 7.12467 8.70898 7.12467Z"
        stroke="#757575"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  new_table: () => (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.125 2.375H3.95833C3.53841 2.375 3.13568 2.54181 2.83875 2.83875C2.54181 3.13568 2.375 3.53841 2.375 3.95833V7.125M7.125 2.375H15.0417C15.4616 2.375 15.8643 2.54181 16.1613 2.83875C16.4582 3.13568 16.625 3.53841 16.625 3.95833V7.125M7.125 2.375V16.625M2.375 7.125V15.0417C2.375 15.4616 2.54181 15.8643 2.83875 16.1613C3.13568 16.4582 3.53841 16.625 3.95833 16.625H7.125M2.375 7.125H16.625M16.625 7.125V15.0417C16.625 15.4616 16.4582 15.8643 16.1613 16.1613C15.8643 16.4582 15.4616 16.625 15.0417 16.625H7.125"
        stroke="#757575"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  speaker_icon: () => (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4102 3.90332C16.8944 5.38791 17.7281 7.40119 17.7281 9.5004C17.7281 11.5996 16.8944 13.6129 15.4102 15.0975M12.6157 6.6979C13.3577 7.4402 13.7746 8.44684 13.7746 9.49645C13.7746 10.5461 13.3577 11.5527 12.6157 12.295M9.02148 3.95874L5.06315 7.1254H1.89648V11.8754H5.06315L9.02148 15.0421V3.95874Z"
        stroke="#757575"
        stroke-width="1.11765"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  smallChatContinuous: (props) => (
    <svg
      width="20"
      height="20.5"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="1" width="39" height="39" rx="4.5" fill="#757575" />
      <rect x="0.5" y="1" width="39" height="39" rx="4.5" stroke="#D9D9D9" />
      <rect
        width="15"
        height="15"
        transform="translate(12.5 13)"
        fill="white"
      />
    </svg>
  ),
  animatedSparkels: ({ className = "w-7 h-7" }) => (
    <svg
      className={`${className}`}
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <style>
          {`
            @keyframes sparkle {
              0% {
                opacity: 0;
                transform: scale(0.6);
              }
              50% {
                opacity: 1;
                transform: scale(1);
              }
              100% {
                opacity: 0;
                transform: scale(0.6);
              }
            }
          `}
        </style>
      </defs>

      {[0, 0.4, 0.8, 1.2].map((delay, i) => (
        <path
          key={i}
          d={
            [
              "M55 47C55.66 47 56.32 47 57 47C57.4009 48.0042 57.8018 49.0084 58.2148 50.043C67.6211 72.9476 82.9741 89.8634 105.875 99.5625C107.911 100.388 109.951 101.206 112 102C112 102.66 112 103.32 112 104C110.892 104.437 110.892 104.437 109.762 104.883C85.6574 114.623 70.0162 128.677 59.4961 152.445C57.9988 155.876 57.9988 155.876 57 159C56.34 159 55.68 159 55 159C54.6597 158.056 54.3194 157.113 53.9688 156.141C46.0805 134.961 31.69 117.627 11 108C7.38958 106.491 3.75354 105.116 0 104C0 103.34 0 102.68 0 102C1.01578 101.588 2.03156 101.175 3.07812 100.75C12.0673 97.014 20.1656 92.8699 28 87C28.7141 86.4702 29.4283 85.9404 30.1641 85.3945C42.1228 75.7465 50.4491 61.5058 55 47Z",
              "M149 0C152.087 1.54345 152.296 4.07247 153.5 7.25C160.608 24.8108 174.549 36.6805 191.68 44.1719C193.434 44.8337 195.214 45.4285 197 46C195.545 48.9096 193.637 49.0532 190.625 50.1875C169.728 58.7047 158.754 73.8307 150 94C147.628 91.6283 147.042 89.6999 145.875 86.5625C142.343 77.8686 136.987 70.2885 130 64C129.161 63.1898 129.161 63.1898 128.305 62.3633C123.06 57.4687 117.387 54.2076 111 51C109.772 50.3754 109.772 50.3754 108.52 49.7383C106.686 48.8133 104.844 47.9046 103 47C105.751 44.2495 109.092 42.9618 112.562 41.3125C130.636 32.4494 141.905 18.7171 149 0Z",
              "M196 84C198.645 87.3808 200.625 90.8961 202.621 94.6836C205.528 99.567 208.602 102.703 213.438 105.688C214.364 106.269 215.291 106.85 216.246 107.449C218.785 108.879 221.27 109.994 224 111C224 111.66 224 112.32 224 113C223.143 113.424 222.286 113.848 221.402 114.285C208.842 120.728 203.227 127.414 197 140C194.725 137.924 193.462 136.131 192.25 133.312C187.162 122.888 178.65 117.055 168 113C169.467 110.066 171.598 109.703 174.562 108.375C185.749 102.848 190.668 94.9316 196 84Z",
              "M135 140C137.714 141.357 137.883 142.793 139.062 145.562C143.294 154.262 150.308 159.207 159 163C158 165 158 165 154.438 166.688C145.089 171.27 140.427 177.727 136 187C133.917 184.292 132.059 181.521 130.25 178.625C125.433 171.4 119.822 167.568 112 164C113.867 162.522 115.733 161.153 117.801 159.969C126.19 155.147 131.09 148.758 135 140Z",
            ][i]
          }
          fill="currentColor"
          style={{
            transformOrigin: "center",
            animation: `sparkle 2s ease-in-out infinite`,
            animationDelay: `${delay}s`,
          }}
        />
      ))}
    </svg>
  ),
  Warningicon: () => (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 18.5V13.5M13.5 8.5H13.5125M26 13.5C26 20.4036 20.4036 26 13.5 26C6.59644 26 1 20.4036 1 13.5C1 6.59644 6.59644 1 13.5 1C20.4036 1 26 6.59644 26 13.5Z"
        stroke="#C00F0C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  RetryButtonIcon: () => (
    <svg
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0833 1.58136V6.58136M19.0833 6.58136H14.0833M19.0833 6.58136L15.2167 2.94803C14.321 2.05196 13.213 1.39737 11.996 1.04534C10.779 0.693313 9.49259 0.655321 8.25691 0.93491C7.02122 1.2145 5.8765 1.80256 4.92956 2.64421C3.98261 3.48586 3.26431 4.55368 2.84167 5.74803M0.75 14.9147V9.9147M0.75 9.9147H5.75M0.75 9.9147L4.61667 13.548C5.51229 14.4441 6.62031 15.0987 7.83734 15.4507C9.05437 15.8027 10.3407 15.8407 11.5764 15.5611C12.8121 15.2816 13.9568 14.6935 14.9038 13.8518C15.8507 13.0102 16.569 11.9424 16.9917 10.748"
        stroke="#1E1E1E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),
  AddTeamMember: () => (
    <svg
      width="17"
      height="17"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.967 1.01091C23.0459 1.07116 23.1241 1.1323 23.2022 1.1935C23.2397 1.22168 23.2771 1.24986 23.3157 1.2789C24.2393 2.02114 24.8738 3.30251 25.0115 4.46027C25.1172 5.82741 24.8961 7.19245 24.0064 8.27988C23.8914 8.41218 23.7748 8.54232 23.6553 8.67056C23.5643 8.7711 23.4826 8.87359 23.4033 8.98349C23.437 8.98809 23.4708 8.99269 23.5056 8.99743C23.6938 9.04332 23.857 9.12481 24.0284 9.21279C24.0811 9.23972 24.0811 9.23972 24.135 9.26719C24.2432 9.32285 24.351 9.37921 24.4587 9.43581C24.491 9.45264 24.5233 9.46947 24.5566 9.48681C25.5084 9.98705 25.5084 9.98705 25.7273 10.4111C25.8164 10.716 25.8177 11.0694 25.6931 11.3645C25.5373 11.6273 25.2874 11.7945 24.998 11.8831C24.5013 11.9649 24.1379 11.711 23.7335 11.4554C22.0811 10.4285 20.0328 10.1409 18.1455 10.5728C17.6673 10.6892 17.2179 10.8415 16.7692 11.0441C16.7116 11.0698 16.654 11.0955 16.5947 11.122C15.9515 11.4258 15.3655 11.826 14.8504 12.3166C14.7589 12.401 14.7589 12.401 14.6584 12.4513C14.6304 12.5399 14.6304 12.5399 14.6152 12.6478C14.608 12.6889 14.6008 12.73 14.5934 12.7723C14.5858 12.8167 14.5782 12.861 14.5704 12.9068C14.366 14.0053 13.8859 15.0051 13.0501 15.7683C13.2283 15.9185 13.4297 16.0044 13.6407 16.0981C13.9551 16.2418 14.2527 16.4008 14.5453 16.585C14.5782 16.6057 14.6111 16.6264 14.645 16.6478C15.051 16.9085 15.2779 17.1242 15.4091 17.5965C15.4144 17.9008 15.3303 18.164 15.1767 18.4257C14.8839 18.6948 14.6029 18.7711 14.2063 18.7557C13.8978 18.7104 13.664 18.5527 13.4045 18.3884C11.6997 17.3106 9.67143 17.0289 7.70942 17.4514C6.2956 17.773 5.05251 18.4976 4.00368 19.4874C3.96662 19.5212 3.92956 19.5551 3.89138 19.5899C3.1789 20.2645 2.67167 21.1522 2.29491 22.0506C2.2789 22.0848 2.2629 22.119 2.24642 22.1542C2.11099 22.4638 2.08248 22.7968 2.17888 23.1231C2.28471 23.3609 2.41335 23.4844 2.64671 23.6086C2.82536 23.6681 2.96768 23.6656 3.15635 23.6661C3.19314 23.6663 3.22992 23.6665 3.26783 23.6666C3.39144 23.6672 3.51505 23.6674 3.63866 23.6676C3.72715 23.6679 3.81565 23.6682 3.90415 23.6686C4.09493 23.6693 4.28572 23.6699 4.4765 23.6704C4.77831 23.6712 5.08011 23.6724 5.38192 23.6736C6.24022 23.6772 7.09852 23.6802 7.95682 23.6828C8.4307 23.6842 8.90457 23.686 9.37844 23.6882C9.6783 23.6895 9.97815 23.6904 10.278 23.691C10.4649 23.6914 10.6518 23.6923 10.8387 23.6933C10.9251 23.6937 11.0116 23.6939 11.0981 23.6939C11.2164 23.6939 11.3348 23.6946 11.4532 23.6954C11.5193 23.6956 11.5854 23.6959 11.6536 23.6961C12.0148 23.7208 12.3371 23.7982 12.5978 24.0609C12.796 24.3521 12.8792 24.6418 12.8145 24.9907C12.7456 25.2624 12.635 25.4473 12.4153 25.6257C12.2158 25.7361 12.0576 25.7476 11.8357 25.7449C11.7749 25.7454 11.7749 25.7454 11.7129 25.7459C11.5776 25.7467 11.4424 25.7461 11.3071 25.7454C11.2099 25.7457 11.1127 25.7461 11.0155 25.7465C10.7517 25.7474 10.488 25.747 10.2242 25.7464C9.94785 25.7459 9.67149 25.7464 9.39513 25.7467C8.93077 25.7471 8.46641 25.7466 8.00205 25.7456C7.46602 25.7445 6.93001 25.7449 6.39399 25.746C5.93327 25.7469 5.47255 25.747 5.01183 25.7465C4.7369 25.7462 4.46197 25.7461 4.18704 25.7468C3.92826 25.7474 3.66951 25.747 3.41073 25.7458C3.31606 25.7456 3.22139 25.7456 3.12672 25.7461C2.62945 25.7482 2.19822 25.7432 1.74207 25.5184C1.70176 25.4994 1.66144 25.4804 1.61991 25.4608C0.913953 25.1156 0.396089 24.438 0.133813 23.7091C-0.0971806 22.941 -0.0177238 22.1306 0.284587 21.3972C0.303962 21.3485 0.303962 21.3485 0.323728 21.2988C0.744246 20.25 1.31212 19.3412 2.04362 18.4823C2.09483 18.4217 2.09483 18.4217 2.14708 18.3599C2.3641 18.1091 2.59398 17.891 2.84774 17.6781C2.8953 17.6362 2.94285 17.5943 2.99184 17.5511C3.8387 16.8085 4.81658 16.2325 5.86323 15.8186C5.86323 15.7854 5.86323 15.7522 5.86323 15.7181C5.81554 15.6725 5.76786 15.6268 5.71873 15.5799C4.83307 14.7121 4.36072 13.4607 4.34077 12.2351C4.33231 10.733 4.78382 9.47041 5.82988 8.36327C6.22093 7.97324 6.67301 7.66437 7.16993 7.42549C7.2136 7.40347 7.25726 7.38144 7.30225 7.35874C8.51892 6.76992 9.9289 6.73191 11.2007 7.16129C12.5203 7.63424 13.495 8.56709 14.1558 9.78762C14.1911 9.87065 14.2254 9.95414 14.2563 10.0389C14.2869 10.0188 14.3175 9.99861 14.349 9.97785C14.9786 9.56953 15.6191 9.21128 16.3169 8.93323C16.2547 8.86171 16.2547 8.86171 16.1912 8.78874C16.1325 8.7197 16.0739 8.65059 16.0153 8.58143C15.9839 8.54495 15.9524 8.50848 15.9199 8.4709C15.4433 7.90104 15.1341 7.27379 14.9097 6.57111C14.8839 6.49298 14.8839 6.49297 14.8576 6.41326C14.4979 5.08153 14.7878 3.65606 15.4594 2.48136C15.6238 2.2199 15.8183 1.98364 16.0153 1.74634C16.0632 1.68366 16.0632 1.68366 16.1119 1.61971C16.3011 1.39388 16.5375 1.22291 16.7692 1.04273C16.8293 0.995691 16.8293 0.995691 16.8905 0.947706C18.6601 -0.366183 21.2221 -0.284684 22.967 1.01091ZM18.679 2.29918C18.6325 2.31932 18.586 2.33947 18.5381 2.36023C17.7792 2.73105 17.2013 3.41769 16.92 4.20898C16.7417 4.83503 16.7188 5.61268 16.9702 6.2193C16.993 6.27482 17.0157 6.33034 17.0392 6.38755C17.3992 7.18098 17.9915 7.71496 18.7829 8.07669C19.4418 8.31094 20.2888 8.34906 20.9406 8.07885C20.9961 8.05611 21.0517 8.03337 21.1089 8.00994C21.9033 7.64946 22.4398 7.05594 22.798 6.26131C23.0616 5.54465 23.0608 4.65732 22.7499 3.95769C22.7298 3.91117 22.7096 3.86466 22.6889 3.81673C22.3152 3.05217 21.6318 2.48983 20.8401 2.19866C20.1572 1.99138 19.3322 2.00895 18.679 2.29918ZM7.22019 9.93839C7.17899 9.97727 7.17899 9.97727 7.13695 10.0169C6.94643 10.2115 6.82819 10.4458 6.70505 10.686C6.68787 10.7192 6.67069 10.7523 6.653 10.7865C6.31053 11.4826 6.3061 12.3672 6.55074 13.096C6.91987 13.9828 7.54974 14.5918 8.42638 14.9642C9.14933 15.233 9.97434 15.1859 10.688 14.9139C11.5196 14.5277 12.1243 13.8594 12.447 13.0041C12.7262 12.2003 12.5867 11.3441 12.2244 10.5937C11.9166 10.0208 11.4735 9.57284 10.889 9.28504C10.842 9.26185 10.795 9.23865 10.7465 9.21476C9.51758 8.65674 8.13882 8.97736 7.22019 9.93839Z"
        fill="black"
      />
      <path
        d="M21.7157 16.4434C21.9515 16.6774 22.0088 16.9261 22.0192 17.2469C22.0191 17.3724 22.018 17.4979 22.016 17.6234C22.0156 17.6904 22.0153 17.7574 22.0151 17.8245C22.0143 17.9996 22.0124 18.1748 22.0101 18.3499C22.0081 18.5292 22.0072 18.7084 22.0061 18.8877C22.004 19.2384 22.0006 19.5892 21.9963 19.9399C22.0305 19.9396 22.0646 19.9393 22.0998 19.9389C22.4569 19.9356 22.814 19.9333 23.1712 19.9317C23.3043 19.9309 23.4373 19.9299 23.5704 19.9286C23.7623 19.9267 23.9541 19.9259 24.146 19.9252C24.205 19.9244 24.264 19.9237 24.3247 19.9229C24.7343 19.9228 25.0999 19.9654 25.4579 20.1755C25.7334 20.4754 25.7971 20.7529 25.7818 21.1577C25.746 21.4674 25.5947 21.6509 25.3636 21.8497C25.1488 21.9754 24.9945 22.0192 24.7464 22.0176C24.6851 22.0176 24.6237 22.0176 24.5605 22.0176C24.495 22.0168 24.4295 22.016 24.362 22.0152C24.2937 22.015 24.2254 22.0147 24.1571 22.0146C23.9781 22.014 23.7992 22.0125 23.6202 22.0109C23.4373 22.0093 23.2543 22.0086 23.0714 22.0079C22.713 22.0063 22.3547 22.0037 21.9963 22.0005C21.9968 22.0571 21.9968 22.0571 21.9973 22.1149C22.0004 22.4713 22.0027 22.8277 22.0041 23.1841C22.0049 23.3673 22.006 23.5505 22.0077 23.7337C22.0093 23.9106 22.0102 24.0876 22.0106 24.2645C22.011 24.3646 22.0122 24.4646 22.0134 24.5647C22.0134 24.626 22.0134 24.6874 22.0134 24.7506C22.0139 24.8313 22.0139 24.8313 22.0145 24.9136C21.9777 25.2232 21.8205 25.4155 21.5943 25.6191C21.3917 25.7541 21.2383 25.7381 21.0006 25.7385C20.9607 25.7397 20.9207 25.7409 20.8796 25.7422C20.6074 25.7435 20.4524 25.7 20.2373 25.5186C20.0436 25.2621 19.9796 25.0857 19.9803 24.7677C19.9803 24.6757 19.9803 24.6757 19.9803 24.5818C19.9806 24.5155 19.9808 24.4492 19.9811 24.3809C19.9812 24.3124 19.9813 24.2439 19.9813 24.1753C19.9815 23.9951 19.982 23.8149 19.9826 23.6347C19.9831 23.4508 19.9833 23.2669 19.9836 23.0829C19.9841 22.7221 19.985 22.3613 19.986 22.0005C19.9294 22.001 19.9294 22.001 19.8717 22.0015C19.5153 22.0046 19.1589 22.0068 18.8025 22.0083C18.6193 22.0091 18.4361 22.0102 18.2528 22.0119C18.0759 22.0135 17.899 22.0144 17.722 22.0148C17.622 22.0152 17.5219 22.0164 17.4219 22.0176C17.3605 22.0176 17.2991 22.0176 17.2359 22.0176C17.1821 22.018 17.1283 22.0183 17.0729 22.0186C16.7665 21.9823 16.5646 21.8276 16.3674 21.5985C16.1712 21.321 16.1788 21.0208 16.2167 20.6938C16.2917 20.4218 16.4325 20.2524 16.6603 20.0911C17.0377 19.916 17.4188 19.9266 17.8265 19.9301C17.8884 19.9303 17.9503 19.9304 18.0141 19.9306C18.2107 19.9311 18.4073 19.9324 18.6039 19.9337C18.7377 19.9342 18.8714 19.9346 19.0052 19.935C19.3321 19.9361 19.6591 19.9378 19.986 19.9399C19.9856 19.9031 19.9851 19.8662 19.9847 19.8282C19.9806 19.4792 19.9776 19.1302 19.9756 18.7813C19.9745 18.6019 19.9731 18.4225 19.9708 18.2431C19.9686 18.0698 19.9675 17.8964 19.9669 17.7231C19.9664 17.6253 19.9648 17.5275 19.9632 17.4298C19.9631 17.0691 19.987 16.8264 20.187 16.5224C20.6147 16.1139 21.2471 16.0473 21.7157 16.4434Z"
        fill="black"
      />
    </svg>
  ),
  filePdf: (props) => (
    <svg
      width="20"
      height="25"
      viewBox="0 0 20 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M13.9664 5.4248C13.4197 5.42427 12.8956 5.20685 12.509 4.82028C12.1224 4.43371 11.905 3.90956 11.9045 3.36287V0.5H2.69089C1.97722 0.5 1.29278 0.783511 0.788145 1.28815C0.283505 1.79279 0 2.47721 0 3.19088V19.4122C0.00105979 20.1252 0.28503 20.8086 0.789555 21.3124C1.29408 21.8161 1.97791 22.0991 2.69089 22.0991H13.7514C14.4644 22.0991 15.1482 21.8161 15.6528 21.3124C16.1573 20.8086 16.4413 20.1252 16.4423 19.4122V5.4248H13.9664Z"
          fill="#5B5B5B"
        />
      </g>
      <path
        d="M16.4421 5.4248H13.9662C13.4195 5.42427 12.8954 5.20685 12.5088 4.82028C12.1222 4.43371 11.9048 3.90956 11.9043 3.36287V0.5L16.4421 5.4248Z"
        fill="#5B5B5B"
      />
      <path
        d="M13.0599 15.583H2.73631C2.63686 15.583 2.54148 15.5434 2.47116 15.4731C2.40083 15.4028 2.36133 15.3074 2.36133 15.208C2.36159 15.1087 2.40122 15.0136 2.47151 14.9435C2.5418 14.8733 2.63703 14.834 2.73631 14.834H13.0599C13.1591 14.834 13.2542 14.8734 13.3243 14.9435C13.3945 15.0136 13.4339 15.1088 13.4339 15.208C13.434 15.2572 13.4244 15.3059 13.4057 15.3514C13.387 15.3969 13.3594 15.4382 13.3247 15.473C13.2899 15.5079 13.2487 15.5355 13.2032 15.5544C13.1578 15.5732 13.1091 15.583 13.0599 15.583Z"
        fill="#5B5B5B"
      />
      <path
        d="M13.0599 11.3593H2.73631C2.63703 11.3593 2.5418 11.3199 2.47151 11.2498C2.40122 11.1797 2.36159 11.0846 2.36133 10.9853C2.36133 10.8859 2.40083 10.7905 2.47116 10.7202C2.54148 10.6498 2.63686 10.6104 2.73631 10.6104H13.0599C13.1091 10.6104 13.1578 10.6201 13.2032 10.6389C13.2487 10.6578 13.2899 10.6854 13.3247 10.7202C13.3594 10.7551 13.387 10.7964 13.4057 10.8419C13.4244 10.8874 13.434 10.9361 13.4339 10.9853C13.4339 11.0845 13.3945 11.1796 13.3243 11.2498C13.2542 11.3199 13.1591 11.3593 13.0599 11.3593Z"
        fill="#5B5B5B"
      />
      <path
        d="M13.0599 13.4716H2.73631C2.63686 13.4716 2.54148 13.4321 2.47116 13.3618C2.40083 13.2915 2.36133 13.1961 2.36133 13.0966C2.36159 12.9974 2.40122 12.9022 2.47151 12.8321C2.5418 12.762 2.63703 12.7227 2.73631 12.7227H13.0599C13.1591 12.7227 13.2542 12.7621 13.3243 12.8322C13.3945 12.9023 13.4339 12.9975 13.4339 13.0966C13.434 13.1458 13.4244 13.1946 13.4057 13.2401C13.387 13.2856 13.3594 13.3269 13.3247 13.3617C13.2899 13.3966 13.2487 13.4242 13.2032 13.4431C13.1578 13.4619 13.1091 13.4716 13.0599 13.4716Z"
        fill="#5B5B5B"
      />
      <path
        d="M8.98805 9.24799H2.73631C2.63703 9.24799 2.5418 9.20863 2.47151 9.13852C2.40122 9.06842 2.36159 8.97329 2.36133 8.87401C2.36133 8.77456 2.40083 8.67918 2.47116 8.60886C2.54148 8.53853 2.63686 8.49902 2.73631 8.49902H8.98805C9.08733 8.49929 9.18246 8.5389 9.25256 8.6092C9.32267 8.67949 9.36204 8.77473 9.36204 8.87401C9.36177 8.97311 9.32229 9.06808 9.25221 9.13816C9.18213 9.20824 9.08716 9.24773 8.98805 9.24799Z"
        fill="#5B5B5B"
      />
      <path
        d="M8.98805 7.13569H2.73631C2.63703 7.13569 2.5418 7.0963 2.47151 7.02619C2.40122 6.95609 2.36159 6.86098 2.36133 6.7617C2.36133 6.66225 2.40083 6.56685 2.47116 6.49653C2.54148 6.42621 2.63686 6.38672 2.73631 6.38672H8.98805C9.08733 6.38698 9.18246 6.4266 9.25256 6.49689C9.32267 6.56719 9.36204 6.66242 9.36204 6.7617C9.36177 6.86081 9.32229 6.95577 9.25221 7.02585C9.18213 7.09593 9.08716 7.13542 8.98805 7.13569Z"
        fill="#5B5B5B"
      />
      <path
        d="M18.3926 17.5605H5.88914C5.0022 17.5605 4.2832 18.2795 4.2832 19.1665V22.8943C4.2832 23.7813 5.0022 24.5003 5.88914 24.5003H18.3926C19.2795 24.5003 19.9986 23.7813 19.9986 22.8943V19.1665C19.9986 18.2795 19.2795 17.5605 18.3926 17.5605Z"
        fill="#5B5B5B"
      />
      <path
        d="M8.38478 21.8369V22.5639H7.63281V21.8369H8.38478Z"
        fill="white"
      />
      <path
        d="M9.4926 21.5095V22.5645H8.76562V19.5576H9.94358C10.3006 19.5576 10.5736 19.6466 10.7605 19.8236C10.8552 19.9166 10.929 20.0285 10.9773 20.1521C11.0255 20.2757 11.0471 20.4081 11.0405 20.5406C11.0442 20.7154 11.001 20.888 10.9155 21.0405C10.8282 21.1897 10.6988 21.3097 10.5436 21.3855C10.3563 21.4741 10.1506 21.5169 9.94358 21.5105L9.4926 21.5095ZM10.3006 20.5406C10.3006 20.2739 10.1546 20.1406 9.86258 20.1406H9.4926V20.9236H9.86258C10.1546 20.9262 10.3006 20.7985 10.3006 20.5406Z"
        fill="white"
      />
      <path
        d="M13.9133 21.8391C13.7881 22.0665 13.599 22.2521 13.3694 22.3731C13.111 22.5054 12.8236 22.571 12.5334 22.5641H11.3984V19.5572H12.5334C12.8238 19.5499 13.1116 19.6141 13.3714 19.7442C13.6004 19.8625 13.789 20.0463 13.9133 20.2722C14.0434 20.5119 14.1089 20.7814 14.1033 21.0541C14.1087 21.3278 14.0433 21.5982 13.9133 21.8391ZM13.1314 21.6881C13.2127 21.6047 13.2756 21.5052 13.3163 21.396C13.3569 21.2868 13.3743 21.1704 13.3674 21.0541C13.3743 20.938 13.357 20.8217 13.3163 20.7127C13.2757 20.6037 13.2127 20.5044 13.1314 20.4212C12.9495 20.2616 12.7119 20.1803 12.4704 20.1952H12.1254V21.9131H12.4704C12.7117 21.9278 12.9491 21.8469 13.1314 21.6881Z"
        fill="white"
      />
      <path
        d="M16.4746 19.5576V20.1366H15.2416V20.7956H16.1936V21.3485H15.2416V22.5645H14.5137V19.5576H16.4746Z"
        fill="white"
      />
      <path
        d="M12.8767 6.38672H11.1088C10.8006 6.38672 10.5508 6.63653 10.5508 6.9447V8.71262C10.5508 9.02078 10.8006 9.2706 11.1088 9.2706H12.8767C13.1848 9.2706 13.4347 9.02078 13.4347 8.71262V6.9447C13.4347 6.63653 13.1848 6.38672 12.8767 6.38672Z"
        fill="#5B5B5B"
      />
    </svg>
  ),
  slack: ({ width = "19", height = "19" }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.60381 11.7282C4.60381 12.7047 3.80616 13.5023 2.82974 13.5023C1.85331 13.5023 1.05566 12.7047 1.05566 11.7282C1.05566 10.7517 1.85331 9.95403 2.82974 9.95403H4.60381V11.7282Z"
        fill="#E01E5A"
      />
      <path
        d="M5.49729 11.7282C5.49729 10.7517 6.29493 9.95405 7.27136 9.95405C8.24779 9.95405 9.04543 10.7517 9.04543 11.7282V16.1705C9.04543 17.1469 8.24779 17.9446 7.27136 17.9446C6.29493 17.9446 5.49729 17.1469 5.49729 16.1705V11.7282Z"
        fill="#E01E5A"
      />
      <path
        d="M7.27136 4.60398C6.29493 4.60398 5.49729 3.80629 5.49729 2.82982C5.49729 1.85335 6.29493 1.05566 7.27136 1.05566C8.24779 1.05566 9.04543 1.85335 9.04543 2.82982V4.60398H7.27136Z"
        fill="#36C5F0"
      />
      <path
        d="M7.27179 5.49793C8.24822 5.49793 9.04586 6.29561 9.04586 7.27209C9.04586 8.24856 8.24822 9.04624 7.27179 9.04624H2.82974C1.85331 9.04624 1.05566 8.24856 1.05566 7.27209C1.05566 6.29561 1.85331 5.49793 2.82974 5.49793H7.27179Z"
        fill="#36C5F0"
      />
      <path
        d="M14.3959 7.27206C14.3959 6.29559 15.1935 5.4979 16.1699 5.4979C17.1464 5.4979 17.944 6.29559 17.944 7.27206C17.944 8.24853 17.1464 9.04621 16.1699 9.04621H14.3959V7.27206Z"
        fill="#2EB67D"
      />
      <path
        d="M13.5024 7.27209C13.5024 8.24856 12.7047 9.04624 11.7283 9.04624C10.7519 9.04624 9.95424 8.24856 9.95424 7.27209V2.82982C9.95424 1.85335 10.7519 1.05566 11.7283 1.05566C12.7047 1.05566 13.5024 1.85335 13.5024 2.82982V7.27209Z"
        fill="#2EB67D"
      />
      <path
        d="M11.7283 14.3963C12.7047 14.3963 13.5024 15.194 13.5024 16.1705C13.5024 17.147 12.7047 17.9447 11.7283 17.9447C10.7519 17.9447 9.95424 17.147 9.95424 16.1705V14.3963H11.7283Z"
        fill="#ECB22E"
      />
      <path
        d="M11.7283 13.5024C10.7519 13.5024 9.95424 12.7047 9.95424 11.7282C9.95424 10.7518 10.7519 9.95408 11.7283 9.95408H16.1704C17.1468 9.95408 17.9444 10.7518 17.9444 11.7282C17.9444 12.7047 17.1468 13.5024 16.1704 13.5024H11.7283Z"
        fill="#ECB22E"
      />
    </svg>
  ),
};

const allIcons = icons;

const Icon = ({ id, ...props }) => {
  const selectedIcon = allIcons[id];
  return selectedIcon ? selectedIcon(props) : null;
};

export default Icon;
